// import { useState, useEffect, useRef } from "react";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import {
//   generateItinerary,
//   generateItineraryStreaming,
//   validateTrip,
//   saveTrip,
//   updateTrip,
//   modifyItinerary,
// } from "../services/api";
// import TransportValidationModal from "../components/plan-trip/TransportValidationModal";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faComments, faMap, faChevronDown } from "@fortawesome/free-solid-svg-icons";
// import Step1Map from "../components/plan-trip/Step1Map";
// import { trackEvent, getPlatform } from "../utils/analytics";

// const API_URL = import.meta.env.VITE_API_URL || "http://localhost:5001";
// import {
//   StepIndicator,
//   Step1Form,
//   Step2Form,
//   Step3Form,
//   Step4Form,
//   Step4TransportForm,
//   ItineraryChatbot,
//   ArrowLeftIcon,
//   ArrowRightIcon,
//   defaultFormData,
//   STEPS,
//   getStoredPlan,
//   setStoredPlan,
//   clearStoredPlan,
// } from "../components/plan-trip";

// const cheapestModeRank = ["road", "drive", "buses", "bus", "trains", "train", "ferry", "flights", "flight"];

// const defaultOptionForLeg = (leg) => {
//   const optionsByMode = leg.optionsByMode || {};
//   const sortedModes = (leg.modeOrder || Object.keys(optionsByMode)).slice().sort((a, b) => {
//     const ra = cheapestModeRank.indexOf(a);
//     const rb = cheapestModeRank.indexOf(b);
//     return (ra === -1 ? 99 : ra) - (rb === -1 ? 99 : rb);
//   });
//   for (const m of sortedModes) {
//     const opts = optionsByMode[m] || [];
//     if (opts.length > 0) return opts[0];
//   }
//   return null;
// };

// const findOptionById = (leg, optionId) => {
//   for (const opts of Object.values(leg.optionsByMode || {})) {
//     const hit = opts.find((o) => o.id === optionId);
//     if (hit) return hit;
//   }
//   return null;
// };

// export default function PlanTrip() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [currentStep, setCurrentStep] = useState(1);
//   const [formData, setFormData] = useState(defaultFormData);
//   const [isAnalyzing, setIsAnalyzing] = useState(false);
//   const [analysisComplete, setAnalysisComplete] = useState(false);
//   const [generatedItinerary, setGeneratedItinerary] = useState(null);
//   const [error, setError] = useState(null);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [editTripId, setEditTripId] = useState(null);
//   const [validationResult, setValidationResult] = useState(null);
//   const [isValidating, setIsValidating] = useState(false);
//   const [isSaving, setIsSaving] = useState(false);
//   const [chatMessages, setChatMessages] = useState([]);
//   const [isModifying, setIsModifying] = useState(false);
//   const [showMobileChat, setShowMobileChat] = useState(false);
//   const [originalItinerary, setOriginalItinerary] = useState(null);
//   const [hasModifications, setHasModifications] = useState(false);
//   const [saveError, setSaveError] = useState(null);
//   const [isPreparingItinerary, setIsPreparingItinerary] = useState(false);
//   const [transportValidation, setTransportValidation] = useState(null);
//   const [selectedLegPlans, setSelectedLegPlans] = useState({});
//   const [activeLeftPanelTab, setActiveLeftPanelTab] = useState("chat");
//   const [isCheckingTransport, setIsCheckingTransport] = useState(false);
//   const [isOptimizePending, setIsOptimizePending] = useState(false);
//   const [isScrolled, setIsScrolled] = useState(false);
//   const streamAbortRef = useRef(null);
//   const rightPanelRef = useRef(null);
//   const editSetupDoneRef = useRef(false);
//   const transportCheckCacheRef = useRef({ key: null, result: null });
//   const mapScrollPerformedRef = useRef(false);
//   const contentTopRef = useRef(null);

//   useEffect(() => {
//     return () => {
//       if (streamAbortRef.current) streamAbortRef.current.abort();
//     };
//   }, []);

//   useEffect(() => {
//     trackEvent(`step_${currentStep}_loaded`);
//   }, [currentStep]);

//   // Auto-scroll to STEP 5 content section when chatbot appears (desktop only, once)
//   useEffect(() => {
//     const showChatbot = currentStep === 5 && analysisComplete && generatedItinerary && !generatedItinerary._streaming && !error;
//     if (showChatbot && contentTopRef.current && !mapScrollPerformedRef.current && window.innerWidth >= 1024) {
//       mapScrollPerformedRef.current = true;
//       setTimeout(() => {
//         rightPanelRef.current?.scrollTo({ top: contentTopRef.current?.offsetTop || 0, behavior: 'smooth' });
//       }, 200);
//     }
//   }, [currentStep, analysisComplete, generatedItinerary, error]);

//   const isCustomNightsValid = () => {
//     const custom = formData.customNightsPerDestination || {};
//     if (Object.keys(custom).length === 0) return true;
//     const nights =
//       formData.startDate && formData.endDate
//         ? Math.max(
//           0,
//           Math.ceil(
//             (new Date(formData.endDate) - new Date(formData.startDate)) /
//             (1000 * 60 * 60 * 24),
//           ),
//         )
//         : 0;
//     const assigned = Object.values(custom).reduce(
//       (s, n) => s + (parseInt(n) || 0),
//       0,
//     );
//     return assigned === nights;
//   };

//   const isStepValid = (step) => {
//     switch (step) {
//       case 1:
//         return (
//           formData.startingLocation?.trim() &&
//           formData.startingLocationData &&
//           formData.destinations?.length >= 1 &&
//           formData.startDate &&
//           formData.endDate &&
//           new Date(formData.endDate) >= new Date(formData.startDate) &&
//           isCustomNightsValid()
//         );
//       case 2:
//         return true;
//       case 3:
//         return true;
//       case 4:
//         return (
//           analysisComplete &&
//           generatedItinerary &&
//           !generatedItinerary._streaming &&
//           !error
//         );
//         if (!transportValidation) return false;
//         const legs = Array.isArray(transportValidation.legPlans) ? transportValidation.legPlans : [];
//         return legs.every((l) => !l.totalOptions || selectedLegPlans[l.key]);
//       case 5:
//         return analysisComplete && generatedItinerary && !generatedItinerary._streaming && !error;
//       default:
//         return true;
//     }
//   };

//   const isInternationalTrip = () => {
//     const sourceCountry = formData.startingLocationData?.country;
//     const destCountry =
//       formData.destinations?.[0]?.country || formData.destinationData?.country;
//     return sourceCountry && destCountry && sourceCountry !== destCountry;
//   };

//   useEffect(() => {
//     if (location.state?.editTrip) {
//       if (editSetupDoneRef.current) return;
//       editSetupDoneRef.current = true;

//       const editTrip = location.state.editTrip;
//       const existingItinerary = location.state.existingItinerary;
//       const tripId = location.state.tripId;

//       const formatDateForInput = (dateStr) => {
//         if (!dateStr) return "";
//         const date = new Date(dateStr);
//         return date.toISOString().split("T")[0];
//       };

//       const editDestinations = editTrip.destinations?.length
//         ? editTrip.destinations
//         : editTrip.destination
//           ? [
//             {
//               name: editTrip.destination,
//               country: editTrip.destinationData?.country,
//               lat: editTrip.destinationData?.lat,
//               lon: editTrip.destinationData?.lon,
//             },
//           ]
//           : [];

//       setFormData({
//         startingLocation: editTrip.startingLocation || "",
//         startingLocationData: editTrip.startingLocationData || null,
//         destination: editTrip.destination || "",
//         destinationData: editTrip.destinationData || null,
//         destinations: editDestinations,
//         customNightsPerDestination: editTrip.customNightsPerDestination || {},
//         startDate: formatDateForInput(editTrip.startDate),
//         endDate: formatDateForInput(editTrip.endDate),
//         themes: editTrip.themes || [],
//         weather: editTrip.weather || [],
//         accommodation: editTrip.accommodation || [],
//         food: editTrip.food || [],
//         travelToDest: (() => {
//           const v = editTrip.travelToDest;
//           return Array.isArray(v) ? v : v ? [v] : [];
//         })(),
//         travelBetween: editTrip.travelBetween || [],
//         travelStyle: editTrip.travelStyle || "",
//         adults: editTrip.adults || 2,
//         children: editTrip.children || 0,
//         infants: editTrip.infants || 0,
//         rooms: editTrip.rooms || [{ adults: editTrip.adults || 2, children: editTrip.children || 0, infants: editTrip.infants || 0 }],
//         budget: editTrip.budget?.toString() || "",
//         currency: editTrip.currency || "INR",
//         preferences: editTrip.preferences || "",
//       });

//       setIsEditMode(true);
//       setEditTripId(tripId);

//       if (existingItinerary) {
//         setGeneratedItinerary(existingItinerary);
//         setAnalysisComplete(true);
//         setCurrentStep(5);
//       }

//       window.history.replaceState({}, document.title);
//     } else if (!editSetupDoneRef.current) {
//       const stored = getStoredPlan();
//       if (stored) {
//         const storedFormData = stored.formData || defaultFormData;
//         if (!storedFormData.rooms && storedFormData.adults) {
//           storedFormData.rooms = [{ adults: storedFormData.adults || 2, children: storedFormData.children || 0, infants: storedFormData.infants || 0 }];
//         }

//         setFormData(storedFormData);
//         setCurrentStep(stored.currentStep || 1);
//         if (stored.validationResult && stored.currentStep === 5) {
//           setValidationResult(stored.validationResult);
//         }
//         if (stored.generatedItinerary && stored.currentStep === 5) {
//           setGeneratedItinerary(stored.generatedItinerary);
//           setAnalysisComplete(true);
//           if (stored.originalItinerary) {
//             setOriginalItinerary(stored.originalItinerary);
//             setHasModifications(stored.hasModifications || false);
//           }
//         }
//         if (
//           stored.currentStep === 4 &&
//           !stored.validationResult &&
//           !stored.generatedItinerary
//         ) {
//           if (stored.transportValidation) {
//             setTransportValidation(stored.transportValidation);
//           }
//           if (stored.selectedLegPlans) {
//             setSelectedLegPlans(stored.selectedLegPlans);
//           }
//           if (stored.currentStep === 4 && !stored.transportValidation) {
//             setCurrentStep(3);
//           }
//           if (stored.currentStep === 5 && !stored.validationResult && !stored.generatedItinerary) {
//             setCurrentStep(3);
//           }
//         }
//       }
//     }, [location.state]);

//   useEffect(() => {
//     document.title = "New Trip | Romaya";
//   }, []);

//   useEffect(() => {
//     const stored = getStoredPlan();
//     setStoredPlan({
//       formData,
//       currentStep,
//       generatedItinerary: generatedItinerary || stored?.generatedItinerary,
//       lastGeneratedFormData: stored?.lastGeneratedFormData,
//       originalItinerary: originalItinerary || stored?.originalItinerary,
//       hasModifications: hasModifications,
//       validationResult: validationResult || stored?.validationResult,
//       transportValidation: transportValidation || stored?.transportValidation,
//       selectedLegPlans: selectedLegPlans || stored?.selectedLegPlans
//     });
//   }, [
//     formData,
//     currentStep,
//     generatedItinerary,
//     originalItinerary,
//     hasModifications,
//     validationResult,
//   ]);

// useEffect(() => {
//   const international = isInternationalTrip();
//   if (international) {
//     if (Array.isArray(formData.travelToDest)) {
//       setFormData((prev) => ({
//         ...prev,
//         travelToDest: prev.travelToDest[0] || "flights",
//       }));
//     } else if (!formData.travelToDest) {
//       setFormData((prev) => ({ ...prev, travelToDest: "flights" }));
//     }
//   } else {
//     if (formData.travelToDest && !Array.isArray(formData.travelToDest)) {
//       setFormData((prev) => ({
//         ...prev,
//         travelToDest: [prev.travelToDest],
//       }));
//     }
//   }
// }, [formData.startingLocationData, formData.destinationData]);

// const scrollToTop = () => {
//   if (rightPanelRef.current) {
//     rightPanelRef.current.scrollTo({ top: 0, behavior: "smooth" });
//   }
//   window.scrollTo({ top: 0, behavior: "smooth" });
// };

// const getStructuralKey = (fd) =>
//   JSON.stringify({
//     destinations: fd.destinations,
//     destination: fd.destination,
//     startingLocation: fd.startingLocation,
//     startDate: fd.startDate,
//     endDate: fd.endDate,
//     themes: fd.themes,
//     travelStyle: fd.travelStyle,
//     weather: fd.weather,
//     accommodation: fd.accommodation,
//     food: fd.food,
//     travelToDest: fd.travelToDest,
//     travelBetween: fd.travelBetween,
//     customNightsPerDestination: fd.customNightsPerDestination,
//     preferences: fd.preferences,
//   });

// const startGeneration = async (fd, { force = false } = {}) => {
//   const stored = getStoredPlan();
//   const structuralChanged =
//     force ||
//     !stored?.lastGeneratedFormData ||
//     getStructuralKey(fd) !== getStructuralKey(stored.lastGeneratedFormData);

//   if (!structuralChanged && stored?.generatedItinerary) {
//     setGeneratedItinerary(stored.generatedItinerary);
//     setAnalysisComplete(true);
//     setCurrentStep(5);
//     scrollToTop();
//     return;
//   }

//   setCurrentStep(5);
//   scrollToTop();
//   setAnalysisComplete(false);
//   setGeneratedItinerary(null);
//   setIsValidating(true);
//   setIsAnalyzing(false);
//   setError(null);
//   setSaveError(null);
//   setValidationResult(null);

//   try {
//     const validation = await validateTrip(fd);
//     setValidationResult(validation);

//     if (!validation.valid) {
//       setIsValidating(false);
//       setIsAnalyzing(false);
//       setAnalysisComplete(true);
//       return;
//     }

//     setIsValidating(false);
//     setIsAnalyzing(true);

//     let buildup = { dayWiseItinerary: [] };
//     const mergeAndShow = (patch) => {
//       buildup = { ...buildup, ...patch };
//       setGeneratedItinerary({
//         ...buildup,
//         dayWiseItinerary: [...(buildup.dayWiseItinerary || [])],
//       });
//     };

//     const controller = new AbortController();
//     if (streamAbortRef.current) streamAbortRef.current.abort();
//     streamAbortRef.current = controller;

//     trackEvent("itinerary_generation_started", {
//       platform: getPlatform(),
//     });

//     const itinerary = await generateItineraryStreaming(fd, {
//       signal: controller.signal,
//       onEvent: (event, payload) => {
//         switch (event) {
//           case "skeleton": {
//             mergeAndShow({
//               tripSummary: {
//                 destination: payload.destination,
//                 startingFrom: payload.startingLocation,
//                 startDate: payload.startDate,
//                 endDate: payload.endDate,
//                 duration: `${payload.numberOfNights} Nights / ${payload.numberOfDays} Days`,
//                 travelers: payload.travelers,
//               },
//               _dayDates: payload.dayDates,
//               _streamPhase: "skeleton",
//               _streamMessage: "Generating itinerary…",
//               _streamLog: ["Generating itinerary…"],
//               _streaming: true,
//             });
//             setIsAnalyzing(false);
//             setAnalysisComplete(true);
//             break;
//           }
//           case "status": {
//             const prevLog = buildup._streamLog || [];
//             const nextLog =
//               prevLog[prevLog.length - 1] === payload.message
//                 ? prevLog
//                 : [...prevLog, payload.message];
//             mergeAndShow({
//               _streamPhase: payload.phase,
//               _streamMessage: payload.message,
//               _streamLog: nextLog,
//             });
//             break;
//           }
//           case "cities": {
//             mergeAndShow({
//               tripSummary: {
//                 ...(buildup.tripSummary || {}),
//                 tripTitle:
//                   payload.tripTitle || buildup.tripSummary?.tripTitle,
//                 overview: payload.overview || buildup.tripSummary?.overview,
//                 citiesBreakdown: payload.citiesBreakdown,
//               },
//               _streamPhase: "cities",
//             });
//             break;
//           }
//           case "trip_summary": {
//             mergeAndShow({
//               tripSummary: {
//                 ...(buildup.tripSummary || {}),
//                 ...(payload.tripSummary || {}),
//               },
//               accommodationDetails: payload.accommodationDetails,
//               inclusions: payload.inclusions,
//               exclusions: payload.exclusions,
//               _streamPhase: "trip_summary",
//             });
//             break;
//           }
//           case "day": {
//             const existing = buildup.dayWiseItinerary || [];
//             const others = existing.filter(
//               (d) => d.dayNumber !== payload.dayNumber,
//             );
//             const next = [...others, payload].sort(
//               (a, b) => (a.dayNumber || 0) - (b.dayNumber || 0),
//             );
//             buildup = {
//               ...buildup,
//               dayWiseItinerary: next,
//               _streamPhase: "day",
//             };
//             setGeneratedItinerary({
//               ...buildup,
//               dayWiseItinerary: [...next],
//             });
//             break;
//           }
//           case "complete": {
//             buildup = {
//               ...payload,
//               _streamPhase: "complete",
//               _streaming: false,
//             };
//             setGeneratedItinerary({ ...payload, _streaming: false });
//             break;
//           }
//           case "error": {
//             setError(
//               payload?.message || "Generation failed. Please try again.",
//             );
//             setAnalysisComplete(true);
//             break;
//           }
//           default:
//             break;
//         }
//       },
//     });
//     const nextLog = prevLog[prevLog.length - 1] === payload.message ? prevLog : [...prevLog, payload.message];
//     mergeAndShow({
//       _streamPhase: payload.phase,
//       _streamMessage: payload.message,
//       _streamLog: nextLog,
//     });
//     break;
//   }
//             case "cities": {
//   mergeAndShow({
//     tripSummary: {
//       ...(buildup.tripSummary || {}),
//       tripTitle: payload.tripTitle || buildup.tripSummary?.tripTitle,
//       overview: payload.overview || buildup.tripSummary?.overview,
//       citiesBreakdown: payload.citiesBreakdown,
//     },
//     _streamPhase: "cities",
//   });
//   break;
// }
//             case "trip_summary": {
//   mergeAndShow({
//     tripSummary: { ...(buildup.tripSummary || {}), ...(payload.tripSummary || {}) },
//     accommodationDetails: payload.accommodationDetails,
//     inclusions: payload.inclusions,
//     exclusions: payload.exclusions,
//     _streamPhase: "trip_summary",
//   });
//   break;
// }
//             case "day": {
//   const existing = buildup.dayWiseItinerary || [];
//   const others = existing.filter(d => d.dayNumber !== payload.dayNumber);
//   const next = [...others, payload].sort((a, b) => (a.dayNumber || 0) - (b.dayNumber || 0));
//   buildup = { ...buildup, dayWiseItinerary: next, _streamPhase: "day" };
//   setGeneratedItinerary({ ...buildup, dayWiseItinerary: [...next] });
//   break;
// }
//             case "complete": {
//   buildup = { ...payload, _streamPhase: "complete", _streaming: false };
//   setGeneratedItinerary({ ...payload, _streaming: false });
//   break;
// }
//             case "error": {
//   setError(payload?.message || "Generation failed. Please try again.");
//   setAnalysisComplete(true);
//   break;
// }
//             default:
// break;
//           }
//         },
//       });

// setGeneratedItinerary(itinerary);
// setOriginalItinerary(itinerary);
// setHasModifications(false);
// setChatMessages([]);
// setGeneratedItinerary(itinerary);
// setOriginalItinerary(itinerary);
// setHasModifications(false);
// setChatMessages([]);

// setStoredPlan({
//   formData: fd,
//   currentStep: 4,
//   generatedItinerary: itinerary,
//   lastGeneratedFormData: fd,
//   originalItinerary: itinerary,
//   hasModifications: false,
// });
// setStoredPlan({
//   formData: fd,
//   currentStep: 5,
//   generatedItinerary: itinerary,
//   lastGeneratedFormData: fd,
//   originalItinerary: itinerary,
//   hasModifications: false
// });

// setAnalysisComplete(true);
//     } catch (err) {
//   if (err.name === "AbortError") return;
//   console.error("Error:", err);
//   if (err.validation) {
//     setValidationResult(err.validation);
//   } else {
//     setError(
//       err.message || "Failed to generate itinerary. Please try again.",
//     );
//   }
//   setAnalysisComplete(true);
// } finally {
//   streamAbortRef.current = null;
//   setIsAnalyzing(false);
//   setIsValidating(false);
// }
// setAnalysisComplete(true);
//     } catch (err) {
//   if (err.name === "AbortError") return;
//   console.error("Error:", err);
//   if (err.validation) {
//     setValidationResult(err.validation);
//   } else {
//     setError(err.message || "Failed to generate itinerary. Please try again.");
//   }
//   setAnalysisComplete(true);
// } finally {
//   streamAbortRef.current = null;
//   setIsAnalyzing(false);
//   setIsValidating(false);
// }
//   };

// const handleNext = async () => {
//   if (currentStep < 4) {
//     trackEvent("continue_clicked", {
//       step: currentStep,
//     });
//   }
//   if (currentStep < 4 && currentStep !== 3) {
//     if (currentStep < 3) {
//       setCurrentStep(currentStep + 1);
//       scrollToTop();
//       return;
//     }

//     if (currentStep === 3) {
//       const between = Array.isArray(formData.travelBetween)
//         ? formData.travelBetween
//         : [];
//       const toDest = formData.travelToDest
//         ? Array.isArray(formData.travelToDest)
//           ? formData.travelToDest
//           : [formData.travelToDest]
//         : [];
//       const allModes = [...new Set([...between, ...toDest])].filter(Boolean);

//       if (formData.destinations.length >= 1 && allModes.length > 0) {
//         const transportCacheKey = JSON.stringify({
//           destinations: formData.destinations.map((d) => d.name || d),
//           startingLocation: formData.startingLocationData?.name,
//           toDest,
//           between,
//         });

//         let result = null;
//         if (
//           transportCheckCacheRef.current.key === transportCacheKey &&
//           transportCheckCacheRef.current.result
//         ) {
//           result = transportCheckCacheRef.current.result;
//         } else {
//           setIsCheckingTransport(true);
//           try {
//             const res = await fetch(
//               `${API_URL}/api/route/validate-and-enhance`,
//               {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({
//                   destinations: formData.destinations,
//                   startingLocation: formData.startingLocationData,
//                   travelToDest: toDest,
//                   travelBetween: between,
//                 }),
//               },
//             );
//             if (res.ok) {
//               result = await res.json();
//               transportCheckCacheRef.current = {
//                 key: transportCacheKey,
//                 result,
//               };
//             }
//           } catch { }
//           setIsCheckingTransport(false);
//         }

//         if (result) {
//           const legPlans = Array.isArray(result.legPlans)
//             ? result.legPlans
//             : [];
//           const shouldOpenModal = legPlans.some(
//             (lp) => lp.needsUserChoice || lp.totalOptions === 0,
//           );
//           if (shouldOpenModal) {
//             setTransportValidation({
//               ...result,
//               transportModes: allModes,
//               originalDestinations: formData.destinations,
//               startingLocationName:
//                 formData.startingLocationData?.name ||
//                 formData.startingLocation,
//             });
//             setShowTransportModal(true);
//             return;
//           }

//           const autoPicks = {};
//           for (const lp of legPlans) {
//             const firstMode =
//               (lp.modeOrder && lp.modeOrder[0]) ||
//               Object.keys(lp.optionsByMode || {})[0];
//             const opt = firstMode && lp.optionsByMode?.[firstMode]?.[0];
//             if (opt) {
//               autoPicks[lp.key] = {
//                 ...opt,
//                 legKey: lp.key,
//                 from: lp.from,
//                 to: lp.to,
//                 type: lp.type,
//               };
//             }
//           }
//           const seededLegPlans = buildLegPlansFromValidation(
//             { legPlans },
//             autoPicks,
//           );
//           const newFormData = { ...formData, legPlans: seededLegPlans };
//           setFormData(newFormData);
//           await startGeneration(newFormData);
//           setTransportValidation({
//             ...result,
//             transportModes: allModes,
//             originalDestinations: formData.destinations,
//             startingLocationName: formData.startingLocationData?.name || formData.startingLocation,
//           });

//           // Pre-populate choices with defaults
//           const init = {};
//           const legs = Array.isArray(result.legPlans) ? result.legPlans : [];
//           for (const leg of legs) {
//             const def = defaultOptionForLeg(leg);
//             if (def) init[leg.key] = def.id;
//           }
//           setSelectedLegPlans(init);

//           setCurrentStep(4);
//           scrollToTop();
//           return;
//         }
//       }

//       const cleanedFormData = { ...formData, legPlans: {} };
//       setFormData(cleanedFormData);
//       await startGeneration(cleanedFormData);
//     }
//   };

//   const buildLegPlansFromValidation = (validation, pickedByLegKey = {}) => {
//     const out = {};
//     const legPlans = validation?.legPlans || [];
//     for (const lp of legPlans) {
//       const picked = pickedByLegKey[lp.key];
//       if (picked && Array.isArray(picked.segments) && picked.segments.length) {
//         out[lp.key] = {
//           type: lp.type,
//           from: lp.from,
//           to: lp.to,
//           primaryMode: picked.primaryMode,
//           segments: picked.segments,
//           distanceKm: lp.distanceKm,
//         };
//       } else if (Array.isArray(lp.workingModes) && lp.workingModes.length > 0) {
//         out[lp.key] = {
//           type: lp.type,
//           from: lp.from,
//           to: lp.to,
//           primaryMode: lp.workingModes[0],
//           segments: [
//             {
//               mode: lp.workingModes[0],
//               from: lp.from,
//               to: lp.to,
//               distanceKm: lp.distanceKm,
//             },
//           ],
//           distanceKm: lp.distanceKm,
//         };
//       }
//     }
//     return out;
//   };

//   const handleTransportClose = () => {
//     setShowTransportModal(false);
//     setTransportValidation(null);
//     setIsCheckingTransport(false);
//     if (formData.legPlans && Object.keys(formData.legPlans).length > 0) {
//       setFormData((prev) => ({ ...prev, legPlans: {} }));
//     }
//   };

//   const handleTransportApplyAndGenerate = async (pickedByLegKey) => {
//     const legPlans = buildLegPlansFromValidation(
//       transportValidation,
//       pickedByLegKey || {},
//     );
//     const handleTransportApplyAndGenerate = async () => {
//       const legs = Array.isArray(transportValidation?.legPlans) ? transportValidation.legPlans : [];
//       const pickedByLegKey = {};
//       for (const leg of legs) {
//         const optId = selectedLegPlans[leg.key];
//         const opt = optId ? findOptionById(leg, optId) : defaultOptionForLeg(leg);
//         if (opt) {
//           pickedByLegKey[leg.key] = {
//             ...opt,
//             legKey: leg.key,
//             from: leg.from,
//             to: leg.to,
//             type: leg.type,
//           };
//         }
//       }

//       const legPlans = buildLegPlansFromValidation(transportValidation, pickedByLegKey);
//       const newFormData = { ...formData, legPlans };
//       setFormData(newFormData);
//       await startGeneration(newFormData);
//     };

//     const handleBack = () => {
//       trackEvent("back_clicked", {
//         step: currentStep,
//       });
//       if (currentStep > 1) {
//         setCurrentStep(currentStep - 1);
//         scrollToTop();
//         if (currentStep === 5) {
//           setIsAnalyzing(false);
//           setIsValidating(false);
//           setError(null);
//           setChatMessages([]);
//           if (streamAbortRef.current) streamAbortRef.current.abort();
//         }
//       } else {
//         navigate("/dashboard");
//       }
//     };

//     const handleSubmit = async () => {
//       if (generatedItinerary) {
//         setSaveError(null);
//         setIsPreparingItinerary(true);
//         await new Promise((resolve) => setTimeout(resolve, 2000));

//         setIsSaving(true);
//         setIsPreparingItinerary(false);

//         try {
//           let tripId = editTripId;

//           if (isEditMode && editTripId) {
//             await updateTrip(editTripId, formData, generatedItinerary);
//           } else {
//             const saveResult = await saveTrip(formData, generatedItinerary);
//             tripId = saveResult.tripId;
//           }

//           clearStoredPlan();

//           navigate("/itinerary", {
//             state: {
//               itinerary: generatedItinerary,
//               tripData: formData,
//               tripId: tripId,
//               fromDashboard: isEditMode,
//               alreadySaved: true,
//             },
//           });
//         } catch (err) {
//           console.error("Failed to save trip:", err);
//           setSaveError("Failed to save trip. Please try again.");
//         } finally {
//           setIsSaving(false);
//         }
//       }
//     };

//     const handleRegenerate = async () => {
//       await startGeneration(formData, { force: true });
//     };

//     const handleRestoreOriginal = () => {
//       if (originalItinerary) {
//         setGeneratedItinerary(originalItinerary);
//         setHasModifications(false);
//         setChatMessages([]);

//         setStoredPlan({
//           formData,
//           currentStep: 5,
//           generatedItinerary: originalItinerary,
//           lastGeneratedFormData: formData,
//           originalItinerary: originalItinerary,
//           hasModifications: false,
//         });
//       }
//     };

//     const handleProceedAnyway = async () => {
//       setIsAnalyzing(true);
//       setValidationResult(null);
//       setError(null);
//       setChatMessages([]);
//       try {
//         trackEvent("validation_override_clicked");

//         trackEvent("itinerary_generation_started", { platform: getPlatform() });
//         const itinerary = await generateItinerary(formData, true);
//         setGeneratedItinerary(itinerary);

//         setOriginalItinerary(itinerary);
//         setHasModifications(false);

//         setStoredPlan({
//           formData,
//           currentStep: 5,
//           generatedItinerary: itinerary,
//           lastGeneratedFormData: formData,
//           originalItinerary: itinerary,
//           hasModifications: false,
//         });
//         setAnalysisComplete(true);
//       } catch (err) {
//         console.error("Error generating itinerary:", err);
//         setError(err.message || "Failed to generate itinerary.");
//         setAnalysisComplete(true);
//       } finally {
//         setIsAnalyzing(false);
//       }
//     };

//     const handleChatMessage = async (message) => {
//       const updatedMessages = [
//         ...chatMessages,
//         { type: "user", content: message },
//       ];
//       setChatMessages(updatedMessages);
//       setIsModifying(true);

//       try {
//         const result = await modifyItinerary(
//           generatedItinerary,
//           message,
//           formData,
//           updatedMessages,
//         );

//         if (result.success) {
//           if (result.modificationType === "off_topic") {
//             setChatMessages((prev) => [
//               ...prev,
//               { type: "assistant", content: result.explanation },
//             ]);
//           } else if (result.modificationType === "needs_clarification") {
//             setChatMessages((prev) => [
//               ...prev,
//               { type: "assistant", content: result.explanation },
//             ]);
//           } else if (result.modificationType !== "no_change") {
//             setGeneratedItinerary(result.itinerary);
//             setHasModifications(true);

//             if (result.formData) {
//               setFormData((prev) => ({ ...prev, ...result.formData }));
//             }

//             setStoredPlan({
//               formData: result.formData || formData,
//               currentStep: 5,
//               generatedItinerary: result.itinerary,
//               lastGeneratedFormData: result.formData || formData,
//               originalItinerary: originalItinerary,
//               hasModifications: true,
//             });

//             setChatMessages((prev) => [
//               ...prev,
//               {
//                 type: "assistant",
//                 content: result.explanation || "Itinerary updated successfully!",
//               },
//             ]);
//           } else {
//             setChatMessages((prev) => [
//               ...prev,
//               {
//                 type: "assistant",
//                 content: result.explanation || "No changes were needed.",
//               },
//             ]);
//           }
//         } else {
//           throw new Error("Failed to modify itinerary");
//         }
//       } catch (err) {
//         console.error("Error modifying itinerary:", err);
//         setChatMessages((prev) => [
//           ...prev,
//           {
//             type: "error",
//             content: `Sorry, I couldn't make that change. ${err.message}`,
//           },
//         ]);
//       } finally {
//         setIsModifying(false);
//       }
//     };

//     const stepInfo = STEPS[currentStep - 1];
//     const showChatbot =
//       currentStep === 4 &&
//       analysisComplete &&
//       generatedItinerary &&
//       !generatedItinerary._streaming &&
//       !error;
//     const stepInfo = STEPS[currentStep - 1] || STEPS[STEPS.length - 1];
//     const showChatbot = currentStep === 5 && analysisComplete && generatedItinerary && !generatedItinerary._streaming && !error;

//     return (
//       <div className="min-h-screen lg:h-screen flex flex-col lg:flex-row lg:overflow-hidden">
//         <div className="lg:w-1/2 lg:h-screen lg:flex-shrink-0 bg-gradient-to-br from-teal-600 to-teal-700 text-white p-6 lg:p-8 flex flex-col overflow-hidden">
//           <div className="flex-shrink-0">
//             <Link to="/" className="flex items-center gap-2 mb-6">
//               <img
//                 src="/RoamMyWay.png"
//                 alt="RoamMyWay"
//                 className="h-8 w-auto brightness-0 invert"
//               />
//               <div className="h-screen flex flex-col lg:flex-row overflow-hidden">
//                 <div className={`lg:w-1/2 lg:h-screen lg:flex-shrink-0 bg-gradient-to-br from-teal-600 to-teal-700 text-white p-4 sm:p-6 lg:p-8 flex flex-col lg:min-h-0 lg:overflow-hidden transition-all duration-300 ${isScrolled ? 'min-h-0' : 'min-h-[320px] sm:min-h-[380px]'}`}>
//                   <div className={`flex-shrink-0 transition-all duration-300 ${isScrolled ? 'mb-3 lg:mb-6' : 'mb-6'} flex items-start justify-between`}>
//                     <Link to="/" className="flex items-center gap-2 mt-1.5">
//                       <img src="/RoamMyWay.png" alt="RoamMyWay" className={`w-auto brightness-0 invert transition-all duration-300 ${isScrolled ? 'h-6 lg:h-8' : 'h-8'}`} />
//                     </Link>
//                     {showChatbot && (
//                       <div className="hidden lg:block text-right select-none max-w-[240px]">
//                         <h1 className="text-base font-bold leading-tight">
//                           {stepInfo.title}
//                         </h1>
//                         <p className="text-teal-100 text-[11px] leading-snug font-medium opacity-90 mt-0.5">
//                           {stepInfo.subtitle}
//                         </p>
//                       </div>
//                     )}
//                   </div>

//                   <div className={`flex-shrink-0 transition-all duration-300 overflow-hidden ${showChatbot ? 'lg:hidden ' : ''}${isScrolled ? 'max-h-0 opacity-0 mb-0 lg:max-h-[300px] lg:opacity-100 lg:mb-4' : 'max-h-[300px] opacity-100 mb-4'}`}>
//                     <div className="mb-4 sm:mb-6 pt-2 px-1">
//                       <StepIndicator currentStep={currentStep} />
//                     </div>
//                     <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold whitespace-pre-line mb-1 sm:mb-3">
//                       {stepInfo.title}
//                     </h1>
//                     <p className="text-teal-100 text-xs sm:text-sm lg:text-base">
//                       {stepInfo.subtitle}
//                     </p>
//                   </div>

//                   <div className="flex flex-col flex-1 min-h-0 mt-2 sm:mt-4 lg:mt-0 lg:overflow-hidden">
//                     {showChatbot ? (
//                       <>
//                         {/* Desktop Container */}
//                         <div className="hidden lg:flex flex-col flex-1 min-h-0 overflow-y-auto scrollbar-thin scroll-smooth space-y-4 pr-2 pb-4">
//                           <div className="w-full h-[400px] shrink-0 rounded-2xl overflow-hidden border border-teal-500/20 shadow-md bg-white relative">
//                             <Step1Map
//                               fromLocation={formData.startingLocationData}
//                               destinations={formData.destinations}
//                             />
//                             {/* Animated scroll indicator */}
//                             <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex flex-col items-center justify-center pointer-events-auto cursor-pointer group">
//                               <div className="flex items-center gap-2.5 bg-white/70 hover:bg-white/95 backdrop-blur-md px-4 py-2 rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.12)] hover:shadow-[0_8px_30px_rgb(0,0,0,0.2)] border border-white/60 transition-all duration-500 transform group-hover:-translate-y-1">
//                                 <span className="text-[10px] font-bold text-teal-900 tracking-[0.2em] uppercase mt-0.5">AI Chat Below</span>
//                                 <div className="w-5 h-5 rounded-lg bg-teal-800/10 flex items-center justify-center group-hover:bg-teal-800/20 transition-colors">
//                                   <FontAwesomeIcon icon={faChevronDown} className="w-2.5 h-2.5 text-teal-900" style={{ animation: 'bounce 2.5s infinite' }} />
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                           <div className="flex-1 flex flex-col min-h-[500px] rounded-2xl overflow-hidden border border-teal-400/20 shadow-lg bg-teal-900/60 backdrop-blur-sm">
//                             <ItineraryChatbot
//                               onSendMessage={handleChatMessage}
//                               isProcessing={isModifying}
//                               messages={chatMessages}
//                               hasModifications={hasModifications}
//                               onRestoreOriginal={handleRestoreOriginal}
//                             />
//                           </div>
//                         </div>
//                         {/* Mobile Map */}
//                         <div className="lg:hidden rounded-2xl overflow-hidden h-[180px] sm:h-[220px]">
//                           <Step1Map
//                             fromLocation={formData.startingLocationData}
//                             destinations={formData.destinations}
//                           />
//                         </div>
//                       </>
//                     ) : (
//                       <div className="rounded-2xl overflow-hidden h-[180px] sm:h-[220px] lg:flex-1 lg:h-full">
//                         <Step1Map
//                           fromLocation={formData.startingLocationData}
//                           destinations={formData.destinations}
//                         />
//                       </div>
//                     )}
//                   </div>
//                 </div>

//                 <div
//                   ref={rightPanelRef}
//                   className="lg:w-1/2 lg:h-screen lg:overflow-y-auto bg-white"
//                 >
//                   <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-12">
//                     <div
//                       ref={rightPanelRef}
//                       onScroll={(e) => setIsScrolled(e.target.scrollTop > 30)}
//                       className="lg:w-1/2 lg:h-screen flex-1 overflow-y-auto bg-white w-full flex flex-col relative"
//                     >

//                       <div ref={contentTopRef} className="flex-1 max-w-2xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-5 sm:py-8 lg:py-12">
//                         <div className="mb-8 flex justify-between items-start">
//                           <div>
//                             <div className="flex items-center gap-2 mb-1">
//                               <p className="text-sm text-teal-600 font-semibold">
//                                 STEP {currentStep} OF 5
//                               </p>
//                               {isEditMode && (
//                                 <span className="px-2 py-0.5 bg-blue-100 text-blue-700 text-xs font-medium rounded-full">
//                                   Editing
//                                 </span>
//                               )}
//                             </div>
//                             <h2 className="text-2xl font-bold text-gray-900">
//                               {currentStep === 1 && "Destination & Dates"}
//                               {currentStep === 2 && "Travel Preferences"}
//                               {currentStep === 3 && "Budget & Travelers"}
//                               {currentStep === 4 &&
//                                 (isEditMode ? "Review Changes" : "AI Suggestions")}
//                               {currentStep === 4 && "Choose Transport"}
//                               {currentStep === 5 && (isEditMode ? "Review Changes" : "AI Suggestions")}
//                             </h2>
//                           </div>

//                           {currentStep < 4 && (

//                             {
//                               currentStep< 5 && (
//                                 <button
//                                   type="button"
//                                   onClick={() => {
//                                     trackEvent("clear_all_clicked", {
//                                       step: currentStep,
//                                     });

//                                     if (currentStep === 1) {
//                                       setFormData((prev) => ({
//                                         ...prev,
//                                         startingLocation: "",
//                                         startingLocationData: null,
//                                         destinations: [],
//                                         destination: "",
//                                         destinationData: null,
//                                         customNightsPerDestination: {},
//                                         startDate: null,
//                                         endDate: null,
//                                         themes: [],
//                                       }));
//                                     } else if (currentStep === 2) {
//                                       setFormData((prev) => ({
//                                         ...prev,
//                                         travelStyle: "",
//                                         weather: [],
//                                         accommodation: [],
//                                         food: [],
//                                         travelToDest: isInternationalTrip() ? "" : [],
//                                         travelBetween: [],
//                                       }));
//                                     } else if (currentStep === 3) {
//                                       setFormData((prev) => ({
//                                         ...prev,
//                                         adults: 1,
//                                         children: 0,
//                                         infants: 0,
//                                         currency: "INR",
//                                         budget: "",
//                                         preferences: "",
//                                       }));
//                                     } else if (currentStep === 4) {
//                                       const init = {};
//                                       const legs = Array.isArray(transportValidation?.legPlans) ? transportValidation.legPlans : [];
//                                       for (const leg of legs) {
//                                         const def = defaultOptionForLeg(leg);
//                                         if (def) init[leg.key] = def.id;
//                                       }
//                                       setSelectedLegPlans(init);
//                                     }
//                                   }}
//                                   className="text-sm text-gray-500 hover:text-red-500 font-medium flex items-center gap-1 cursor-pointer transition-colors mt-1"
//                                   title={currentStep === 4 ? "Reset Selections" : `Clear Step ${currentStep}`}
//                                 >
//                                   <svg
//                                     className="w-4 h-4"
//                                     fill="none"
//                                     stroke="currentColor"
//                                     viewBox="0 0 24 24"
//                                   >
//                                     <path
//                                       strokeLinecap="round"
//                                       strokeLinejoin="round"
//                                       strokeWidth={2}
//                                       d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
//                                     />
//                                   </svg>
//                                   {currentStep === 4 ? "Reset Selections" : "Clear All"}
//                                 </button>
//                               )
//                             }
//           </div>

//                         <div className="mb-12">
//                           {currentStep === 1 && (
//                             <Step1Form
//                               formData={formData}
//                               setFormData={setFormData}
//                               onOptimizePendingChange={setIsOptimizePending}
//                             />
//                           )}
//                           {currentStep === 2 && (
//                             <Step2Form
//                               formData={formData}
//                               setFormData={setFormData}
//                               isInternationalTrip={isInternationalTrip()}
//                             />
//                           )}
//                           {currentStep === 3 && (
//                             <Step3Form formData={formData} setFormData={setFormData} />
//                           )}
//                           {currentStep === 4 && (
//                             <Step4TransportForm
//                               validation={transportValidation}
//                               selected={selectedLegPlans}
//                               onSelect={(legKey, optionId) => {
//                                 setSelectedLegPlans((prev) => ({ ...prev, [legKey]: optionId }));
//                               }}
//                             />
//                           )}
//                           {currentStep === 5 && (
//                             <Step4Form
//                               formData={formData}
//                               isAnalyzing={isAnalyzing}
//                               isValidating={isValidating}
//                               analysisComplete={analysisComplete}
//                               itinerary={generatedItinerary}
//                               error={error}
//                               saveError={saveError}
//                               onRetrySave={handleSubmit}
//                               validationResult={validationResult}
//                               isEditMode={isEditMode}
//                               onRegenerate={handleRegenerate}
//                               onProceedAnyway={handleProceedAnyway}
//                               onGoToStep={setCurrentStep}
//                             />
//                           )}
//                         </div>
//                       </div>

//                       <div className="sticky bottom-0 bg-white border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)] z-20">
//                         <div className="max-w-2xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
//                           <button
//                             onClick={handleBack}
//                             disabled={isCheckingTransport}
//                             className={`inline-flex items-center gap-2 px-6 py-3 border rounded-full font-medium transition-colors ${isCheckingTransport
//                               ? "border-gray-200 text-gray-300 cursor-not-allowed"
//                               : "border-gray-300 text-gray-700 hover:bg-gray-50"
//                               }`}
//                           >
//                             <ArrowLeftIcon />
//                             Back
//                           </button>

//                           {currentStep < 4 ? (
//                             <button
//                               onClick={handleNext}
//                               disabled={
//                                 !isStepValid(currentStep) ||
//                                 isCheckingTransport ||
//                                 (isOptimizePending && currentStep === 1)
//                               }
//                               className={`inline-flex items-center gap-2 px-6 py-3 rounded-full font-medium transition-colors ${isStepValid(currentStep) &&
//                                 !isCheckingTransport &&
//                                 !(isOptimizePending && currentStep === 1)
//             {currentStep < 5 ? (
//                                 currentStep === 4 ? (
//                                   <button
//                                     onClick={handleTransportApplyAndGenerate}
//                                     disabled={!isStepValid(4) || isAnalyzing}
//                                     className={`inline-flex items-center gap-2 px-6 py-3 rounded-full font-medium transition-colors ${isStepValid(4) && !isAnalyzing
//                                       ? "bg-teal-600 text-white hover:bg-teal-700 cursor-pointer"
//                                       : "bg-gray-300 text-gray-500 cursor-not-allowed"
//                                       }`}
//                                   >
//                                     {isAnalyzing ? (
//                                       <>
//                                         <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
//                                           <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
//                                           <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
//                                         </svg>
//                                         Generating...
//                                       </>
//                                     ) : (
//                                       <>
//                                         Generate Itinerary
//                                         <ArrowRightIcon />
//                                       </>
//                                     )}
//                                   </button>
//                                 ) : (
//                                   <button
//                                     onClick={handleNext}
//                                     disabled={!isStepValid(currentStep) || isCheckingTransport || (isOptimizePending && currentStep === 1)}
//                                     className={`inline-flex items-center gap-2 px-6 py-3 rounded-full font-medium transition-colors ${isStepValid(currentStep) && !isCheckingTransport && !(isOptimizePending && currentStep === 1)
//                                       ? "bg-teal-600 text-white hover:bg-teal-700 cursor-pointer"
//                                       : "bg-gray-300 text-gray-500 cursor-not-allowed"
//                                       }`}
//                                   >
//                                     {isCheckingTransport && currentStep === 3 ? (
//                                       <>
//                                         <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
//                                           <circle
//                                             className="opacity-25"
//                                             cx="12"
//                                             cy="12"
//                                             r="10"
//                                             stroke="currentColor"
//                                             strokeWidth="4"
//                                             fill="none"
//                                           />
//                                           <path
//                                             className="opacity-75"
//                                             fill="currentColor"
//                                             d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                                           />
//                                         </svg>
//                                         Checking route...
//                                       </>
//                                     ) : (
//                                       <>
//                                         Continue
//                                         <ArrowRightIcon />
//                                       </>
//                                     )}
//                                   </button>
//                                 ) : analysisComplete &&
//                                   generatedItinerary &&
//                                   !error &&
//                                   !generatedItinerary._streaming ? (
//                     }`}
//                 >
//                   {isCheckingTransport && currentStep === 3 ? (
//                     <>
//                       <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
//                         <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
//                         <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
//                       </svg>
//                       Checking route...
//                     </>
//                   ) : (
//                     <>
//                       Continue
//                       <ArrowRightIcon />
//                     </>
//                   )}
//                 </button>
//               )
//             ) : analysisComplete && generatedItinerary && !error && !generatedItinerary._streaming ? (
//               <button
//                 onClick={handleSubmit}
//                 disabled={isSaving || isPreparingItinerary}
//                 className={`inline-flex items-center gap-2 px-8 py-3 rounded-full font-medium transition-colors ${isSaving || isPreparingItinerary
//                             ? "bg-teal-400 text-white cursor-not-allowed"
//                             : "bg-teal-600 text-white hover:bg-teal-700 cursor-pointer"
//                           }`}
//               >
//                           {isSaving || isPreparingItinerary ? (
//                             <>
//                               <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
//                                 <circle
//                                   className="opacity-25"
//                                   cx="12"
//                                   cy="12"
//                                   r="10"
//                                   stroke="currentColor"
//                                   strokeWidth="4"
//                                   fill="none"
//                                 />
//                                 <path
//                                   className="opacity-75"
//                                   fill="currentColor"
//                                   d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                                 />
//                               </svg>
//                               {isPreparingItinerary ? "Preparing..." : "Saving..."}
//                             </>
//                           ) : (
//                             <>
//                               View Full Itinerary
//                               <ArrowRightIcon />
//                             </>
//                           )}
//                         </button>
//             ) : null}
//                       </div>
//                     </div>
//                   </div>

//                   {showChatbot && (
//                     <>
//                       <button
//                         onClick={() => setShowMobileChat(true)}
//                         className="lg:hidden fixed bottom-6 right-6 w-14 h-14 bg-teal-600 text-white rounded-full shadow-lg flex items-center justify-center hover:bg-teal-700 transition-colors z-40"
//                       >
//                         <svg
//                           className="w-6 h-6"
//                           fill="none"
//                           stroke="currentColor"
//                           viewBox="0 0 24 24"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth={2}
//                             d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
//                           />
//                         </svg>
//                       </button>
//                       <div className="lg:hidden fixed bottom-24 right-6 z-40 flex flex-col items-center gap-1.5">
//                         <button
//                           onClick={() => setShowMobileChat(true)}
//                           className="w-14 h-14 bg-teal-600 text-white rounded-full shadow-lg flex items-center justify-center hover:bg-teal-700 hover:scale-110 active:scale-95 transition-all animate-bounce hover:animate-none"
//                         >
//                           <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
//                           </svg>
//                         </button>
//                         <span className="text-[11px] font-semibold text-teal-800 bg-white/90 backdrop-blur px-2.5 py-0.5 rounded-full shadow-sm whitespace-nowrap">
//                           Edit Itinerary
//                         </span>
//                       </div>

//                       {showMobileChat && (
//                         <div className="lg:hidden fixed inset-0 z-50 flex flex-col">
//                           <div
//                             className="absolute inset-0 bg-black/50"
//                             onClick={() => setShowMobileChat(false)}
//                           />

//                           <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-br from-teal-600 to-teal-700 rounded-t-3xl p-6 pt-12 max-h-[85vh] flex flex-col shadow-2xl">
//                             <button
//                               onClick={() => setShowMobileChat(false)}
//                               className="absolute top-4 right-4 p-2 bg-black/10 rounded-full text-white/90 hover:text-white hover:bg-black/20 transition-colors z-10"
//                             >
//                               <svg
//                                 className="w-6 h-6"
//                                 fill="none"
//                                 stroke="currentColor"
//                                 viewBox="0 0 24 24"
//                               >
//                                 <path
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                   strokeWidth={2}
//                                   d="M6 18L18 6M6 6l12 12"
//                                 />
//                                 <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                                 </svg>
//                             </button>

//                             <ItineraryChatbot
//                               onSendMessage={handleChatMessage}
//                               isProcessing={isModifying}
//                               messages={chatMessages}
//                               hasModifications={hasModifications}
//                               onRestoreOriginal={handleRestoreOriginal}
//                             />
//                           </div>
//                         </div>
//                       )}
//                     </>
//                   )}

//                   {isPreparingItinerary && (
//                     <div className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-teal-600 to-teal-800">
//                       <div className="text-center text-white px-8">
//                         <div className="relative mb-8">
//                           <div className="w-24 h-24 border-4 border-white/20 rounded-full animate-spin border-t-white mx-auto"></div>
//                           <div className="absolute inset-0 flex items-center justify-center">
//                             <span className="text-4xl">✨</span>
//                           </div>
//                         </div>
//                         <h2 className="text-2xl font-bold mb-3">
//                           Romaya is finalizing your adventure...
//                         </h2>
//                         <p className="text-teal-100 text-lg mb-6">
//                           Adding the finishing touches to your perfect trip
//                         </p>
//                         <div className="flex items-center justify-center gap-3 text-teal-200 text-sm">
//                           <span className="w-2 h-2 bg-white rounded-full animate-pulse"></span>
//                           <span className="animate-pulse">
//                             Preparing your personalized itinerary
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//                 );
// }




import { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  generateItinerary,
  generateItineraryStreaming,
  validateTrip,
  saveTrip,
  updateTrip,
  modifyItinerary,
  routePost,
} from "../services/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments, faMap, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import Step1Map from "../components/plan-trip/Step1Map";
import { trackEvent } from "../utils/analytics";
import { getPlatform } from "../utils/analytics";
import { hydrateStopsFromTrip } from "../utils/stopsMigration";
import * as Sentry from "@sentry/react";
import { AIError } from "../errors/sentryErrors";
import { API_URL } from "../config";


import {
  StepIndicator,
  Step1Form,
  Step2Form,
  Step3Form,
  Step4Form,
  Step4TransportForm,
  ItineraryChatbot,
  ArrowLeftIcon,
  ArrowRightIcon,
  defaultFormData,
  STEPS,
  getStoredPlan,
  setStoredPlan,
  clearStoredPlan,
} from "../components/plan-trip";

const cheapestModeRank = ["road", "drive", "buses", "bus", "trains", "train", "ferry", "flights", "flight"];

const defaultOptionForLeg = (leg) => {
  const optionsByMode = leg.optionsByMode || {};
  const sortedModes = (leg.modeOrder || Object.keys(optionsByMode)).slice().sort((a, b) => {
    const ra = cheapestModeRank.indexOf(a);
    const rb = cheapestModeRank.indexOf(b);
    return (ra === -1 ? 99 : ra) - (rb === -1 ? 99 : rb);
  });
  for (const m of sortedModes) {
    const opts = optionsByMode[m] || [];
    if (opts.length > 0) return { ...opts[0], primaryMode: m };
  }
  return null;
};

const findOptionById = (leg, optionId) => {
  for (const [mode, opts] of Object.entries(leg.optionsByMode || {})) {
    const hit = opts.find((o) => o.id === optionId);
    if (hit) return { ...hit, primaryMode: mode };
  }
  return null;
};

// Single top-level definition of buildLegPlansFromValidation
const buildLegPlansFromValidation = (validation, pickedByLegKey = {}) => {
  const out = {};
  const legPlans = validation?.legPlans || [];
  for (const lp of legPlans) {
    const picked = pickedByLegKey[lp.key];
    if (picked && Array.isArray(picked.segments) && picked.segments.length) {
      out[lp.key] = {
        type: lp.type,
        from: lp.from,
        to: lp.to,
        primaryMode: picked.primaryMode,
        segments: picked.segments,
        distanceKm: lp.distanceKm,
      };
    } else if (Array.isArray(lp.workingModes) && lp.workingModes.length > 0) {
      out[lp.key] = {
        type: lp.type,
        from: lp.from,
        to: lp.to,
        primaryMode: lp.workingModes[0],
        segments: [
          {
            mode: lp.workingModes[0],
            from: lp.from,
            to: lp.to,
            distanceKm: lp.distanceKm,
          },
        ],
        distanceKm: lp.distanceKm,
      };
    }
  }
  return out;
};

const normalizeRooms = (rooms) => {
  if (!Array.isArray(rooms)) return [];
  return rooms.map(room => {
    let children = [];
    if (Array.isArray(room.children)) {
      children = room.children.map(child => {
        if (child && typeof child === 'object') {
          return child;
        }
        return { age: child };
      });
    } else if (typeof room.children === 'number') {
      children = Array.from({ length: room.children }, () => ({ age: "" }));
    }
    return {
      ...room,
      adults: parseInt(room.adults, 10) || 0,
      children
    };
  });
};

const ACCOMMODATION_MAP = {
  "3star": "3 Star",
  "4star": "4 Star",
  "5star": "5 Star",
  "airbnb": "AirBnb",
  "homestay": "Homestay"
};

const normalizeAccommodation = (accommodation) => {
  if (!Array.isArray(accommodation)) return ["3 Star", "4 Star"];
  return accommodation.map(acc => ACCOMMODATION_MAP[acc] || acc);
};

export default function PlanTrip() {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentStep, setCurrentStep] = useState(1);
  // Set only when Continue is clicked on an invalid step, so a step's inline
  // "missing field" messages don't show before the user has touched anything.
  const [showStepErrors, setShowStepErrors] = useState(false);
  const [formData, setFormData] = useState(defaultFormData);
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [analysisComplete, setAnalysisComplete] = useState(false);
  const [generatedItinerary, setGeneratedItinerary] = useState(null);
  const [error, setError] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editTripId, setEditTripId] = useState(null);
  const [validationResult, setValidationResult] = useState(null);
  const [isValidating, setIsValidating] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  const [isModifying, setIsModifying] = useState(false);
  const [showMobileChat, setShowMobileChat] = useState(false);
  const [originalItinerary, setOriginalItinerary] = useState(null);
  const [hasModifications, setHasModifications] = useState(false);
  const [saveError, setSaveError] = useState(null);
  const [isPreparingItinerary, setIsPreparingItinerary] = useState(false);
  const [transportValidation, setTransportValidation] = useState(null);
  const [selectedLegPlans, setSelectedLegPlans] = useState({});
  const [activeLeftPanelTab, setActiveLeftPanelTab] = useState("chat");
  const [isCheckingTransport, setIsCheckingTransport] = useState(false);
  const [isOptimizePending, setIsOptimizePending] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const streamAbortRef = useRef(null);
  const rightPanelRef = useRef(null);
  const editSetupDoneRef = useRef(false);
  const transportCheckCacheRef = useRef({ key: null, result: null });
  const mapScrollPerformedRef = useRef(false);
  const contentTopRef = useRef(null);

  useEffect(() => {
    return () => {
      if (streamAbortRef.current) streamAbortRef.current.abort();
    };
  }, []);

  useEffect(() => {
    trackEvent(`step_${currentStep}_loaded`);
  }, [currentStep]);

  // Auto-scroll to STEP 5 content section when chatbot appears (desktop only, once)
  useEffect(() => {
    const showChatbot = currentStep === 5 && analysisComplete && generatedItinerary && !generatedItinerary._streaming && !error;
    if (showChatbot && contentTopRef.current && !mapScrollPerformedRef.current && window.innerWidth >= 1024) {
      mapScrollPerformedRef.current = true;
      setTimeout(() => {
        rightPanelRef.current?.scrollTo({ top: contentTopRef.current?.offsetTop || 0, behavior: 'smooth' });
      }, 200);
    }
  }, [currentStep, analysisComplete, generatedItinerary, error]);

  const isCustomNightsValid = () => {
    const custom = formData.customNightsPerDestination || {};
    if (Object.keys(custom).length === 0) return true;
    const nights =
      formData.startDate && formData.endDate
        ? Math.max(
          0,
          Math.ceil(
            (new Date(formData.endDate) - new Date(formData.startDate)) /
            (1000 * 60 * 60 * 24),
          ),
        )
        : 0;
    const assigned = Object.values(custom).reduce(
      (s, n) => s + (parseInt(n) || 0),
      0,
    );
    return assigned === nights;
  };

  // Clears the "you tried to continue and this step is invalid" flag
  // whenever the step actually changes, so the next step (or coming back to
  // this one later) starts without a stale error showing.
  useEffect(() => {
    setShowStepErrors(false);
  }, [currentStep]);

  const isStepValid = (step) => {
    switch (step) {
      case 1:
        return (
          formData.startingLocation?.trim() &&
          formData.startingLocationData &&
          formData.destinations?.length >= 1 &&
          formData.startDate &&
          formData.endDate &&
          new Date(formData.endDate) >= new Date(formData.startDate) &&
          isCustomNightsValid()
        );
      case 2:
        return (
          formData.accommodation && formData.accommodation.length > 0 &&
          formData.travelToDest && formData.travelToDest.length > 0 &&
          formData.tripType && formData.tripType.trim().length > 0
        );
      case 3:
        if (!transportValidation) return false;
        const legs = Array.isArray(transportValidation.legPlans) ? transportValidation.legPlans : [];
        return legs.every((l) => !l.totalOptions || selectedLegPlans[l.key]);
      case 4: {
        const rooms = formData.rooms || [];
        if (rooms.length === 0) return false;

        let totalAdultsOverall = 0;
        let hasInvalidChildAge = false;

        rooms.forEach((room) => {
          const childrenAges = room.children || [];
          const adultsFromChildren = childrenAges.filter(child => {
            const age = (child && typeof child === "object") ? child.age : child;
            return age > 12;
          }).length;
          totalAdultsOverall += room.adults + adultsFromChildren;

          childrenAges.forEach(child => {
            const age = (child && typeof child === "object") ? child.age : child;
            if (age === "" || age === undefined || age === null || age < 0 || age > 17) {
              hasInvalidChildAge = true;
            }
          });
        });

        if (totalAdultsOverall === 0) return false;
        if (hasInvalidChildAge) return false;

        return true;
      }
      case 5:
        return analysisComplete && generatedItinerary && !generatedItinerary._streaming && !error;
      default:
        return true;
    }
  };

  // Mirrors isStepValid's checks but explains which field is still missing,
  // since the Continue button used to just stay greyed out with no
  // indication of what was wrong.
  const getStepValidationMessage = (step) => {
    switch (step) {
      case 1: {
        const missing = [];
        if (!formData.startingLocation?.trim() || !formData.startingLocationData) {
          missing.push("a starting location");
        }
        if (!(formData.destinations?.length >= 1)) {
          missing.push("at least one destination");
        }
        if (!formData.startDate || !formData.endDate) {
          missing.push("your travel dates");
        } else if (new Date(formData.endDate) < new Date(formData.startDate)) {
          missing.push("an end date on or after the start date");
        }
        if (!isCustomNightsValid()) {
          missing.push("nights that add up to your trip duration");
        }
        return missing.length ? `Please add ${missing.join(", ")} to continue.` : null;
      }
      case 2: {
        const missing = [];
        if (!(formData.accommodation && formData.accommodation.length > 0)) {
          missing.push("an accommodation type");
        }
        if (!(formData.travelToDest && formData.travelToDest.length > 0)) {
          missing.push("how you'll travel to your destination");
        }
        if (!(formData.tripType && formData.tripType.trim().length > 0)) {
          missing.push("who you're traveling with");
        }
        return missing.length ? `Please select ${missing.join(" and ")} to continue.` : null;
      }
      case 3: {
        if (!transportValidation) return "Please wait for transport options to finish loading.";
        const legs = Array.isArray(transportValidation.legPlans) ? transportValidation.legPlans : [];
        const unselected = legs.filter((l) => l.totalOptions && !selectedLegPlans[l.key]);
        if (unselected.length > 0) {
          return `Please choose a transport option for ${unselected.map((l) => l.label || l.key).join(", ")}.`;
        }
        return null;
      }
      case 4: {
        const rooms = formData.rooms || [];
        if (rooms.length === 0) return "Please add at least one room for your travelers.";

        let totalAdultsOverall = 0;
        let hasInvalidChildAge = false;

        rooms.forEach((room) => {
          const childrenAges = room.children || [];
          const adultsFromChildren = childrenAges.filter(child => {
            const age = (child && typeof child === "object") ? child.age : child;
            return age > 12;
          }).length;
          totalAdultsOverall += room.adults + adultsFromChildren;

          childrenAges.forEach(child => {
            const age = (child && typeof child === "object") ? child.age : child;
            if (age === "" || age === undefined || age === null || age < 0 || age > 17) {
              hasInvalidChildAge = true;
            }
          });
        });

        if (totalAdultsOverall === 0) return "Please add at least one adult traveler.";
        if (hasInvalidChildAge) return "Please enter a valid age (0–17) for every child.";
        return null;
      }
      default:
        return null;
    }
  };

  const isInternationalTrip = () => {
    const sourceCountry = formData.startingLocationData?.country;
    const destCountry =
      formData.destinations?.[0]?.country || formData.destinationData?.country;
    return sourceCountry && destCountry && sourceCountry !== destCountry;
  };

  useEffect(() => {
    if (location.state?.editTrip) {
      if (editSetupDoneRef.current) return;
      editSetupDoneRef.current = true;

      const editTrip = location.state.editTrip;
      const existingItinerary = location.state.existingItinerary;
      const tripId = location.state.tripId;

      const formatDateForInput = (dateStr) => {
        if (!dateStr) return "";
        const date = new Date(dateStr);
        return date.toISOString().split("T")[0];
      };

      const editDestinations = editTrip.destinations?.length
        ? editTrip.destinations
        : editTrip.destination
          ? [
            {
              name: editTrip.destination,
              country: editTrip.destinationData?.country,
              lat: editTrip.destinationData?.lat,
              lon: editTrip.destinationData?.lon,
            },
          ]
          : [];

      setFormData({
        startingLocation: editTrip.startingLocation || "",
        startingLocationData: editTrip.startingLocationData || null,
        destination: editTrip.destination || "",
        destinationData: editTrip.destinationData || null,
        destinations: editDestinations,
        stops: hydrateStopsFromTrip({
          ...editTrip,
          destinations: editDestinations,
        }),
        customNightsPerDestination: editTrip.customNightsPerDestination || {},
        startDate: formatDateForInput(editTrip.startDate),
        endDate: formatDateForInput(editTrip.endDate),
        themes: editTrip.themes || [],
        weather: editTrip.weather || [],
        accommodation: normalizeAccommodation(editTrip.accommodation),
        food: editTrip.food || [],
        travelToDest: (() => {
          const v = editTrip.travelToDest;
          return Array.isArray(v) ? v : v ? [v] : [];
        })(),
        travelBetween: editTrip.travelBetween || [],
        travelStyle: editTrip.travelStyle || "",
        adults: editTrip.adults || 2,
        children: editTrip.children || 0,
        infants: editTrip.infants || 0,
        rooms: normalizeRooms(editTrip.rooms || [{ adults: editTrip.adults || 2, children: editTrip.children || 0, infants: editTrip.infants || 0 }]),
        budget: editTrip.budget?.toString() || "",
        currency: editTrip.currency || "INR",
        preferences: editTrip.preferences || "",
        mealPlan: editTrip.mealPlan || "MAP",
        tripType: editTrip.tripType || "",
        includeTransport: editTrip.includeTransport !== false,
      });

      setIsEditMode(true);
      setEditTripId(tripId);
      
      if (editTrip.legPlans && Array.isArray(editTrip.legPlans)) {
        const loadedLegPlans = {};
        editTrip.legPlans.forEach(lp => {
          if (lp.legKey && lp.id) {
            loadedLegPlans[lp.legKey] = lp.id;
          }
        });
        setSelectedLegPlans(loadedLegPlans);
      }

      if (existingItinerary) {
        setGeneratedItinerary(existingItinerary);
        setAnalysisComplete(true);
        setCurrentStep(5);
      }

      window.history.replaceState({}, document.title);
    } else if (!editSetupDoneRef.current) {
      const stored = getStoredPlan();
      if (stored) {
        const storedFormData = stored.formData || defaultFormData;
        if (!storedFormData.rooms && storedFormData.adults) {
          storedFormData.rooms = [{ adults: storedFormData.adults || 2, children: storedFormData.children || 0, infants: storedFormData.infants || 0 }];
        }
        if (storedFormData.rooms) {
          storedFormData.rooms = normalizeRooms(storedFormData.rooms);
        }
        if (storedFormData.accommodation) {
          storedFormData.accommodation = normalizeAccommodation(storedFormData.accommodation);
        }

        setFormData(storedFormData);
        setCurrentStep(stored.currentStep || 1);
        if (stored.validationResult && stored.currentStep === 5) {
          setValidationResult(stored.validationResult);
        }
        if (stored.generatedItinerary && stored.currentStep === 5) {
          setGeneratedItinerary(stored.generatedItinerary);
          setAnalysisComplete(true);
          if (stored.originalItinerary) {
            setOriginalItinerary(stored.originalItinerary);
            setHasModifications(stored.hasModifications || false);
          }
        }
        if (
          stored.currentStep === 4 &&
          !stored.validationResult &&
          !stored.generatedItinerary
        ) {
          if (stored.transportValidation) {
            setTransportValidation(stored.transportValidation);
          }
          if (stored.selectedLegPlans) {
            setSelectedLegPlans(stored.selectedLegPlans);
          }
          if (stored.currentStep === 4 && !stored.transportValidation) {
            setCurrentStep(3);
          }
          if (stored.currentStep === 5 && !stored.validationResult && !stored.generatedItinerary) {
            setCurrentStep(3);
          }
        }
      }
    }
  }, [location.state]);

  useEffect(() => {
    document.title = "New Trip | Romaya";
  }, []);

  const isInitialMount = useRef(true);
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    const stored = getStoredPlan();
    setStoredPlan({
      formData,
      currentStep,
      generatedItinerary: generatedItinerary || stored?.generatedItinerary,
      lastGeneratedFormData: stored?.lastGeneratedFormData,
      originalItinerary: originalItinerary || stored?.originalItinerary,
      hasModifications: hasModifications,
      validationResult: validationResult || stored?.validationResult,
      transportValidation: transportValidation || stored?.transportValidation,
      selectedLegPlans: selectedLegPlans || stored?.selectedLegPlans
    });
  }, [
    formData,
    currentStep,
    generatedItinerary,
    originalItinerary,
    hasModifications,
    validationResult,
    transportValidation,
    selectedLegPlans
  ]);

  useEffect(() => {
    const international = isInternationalTrip();
    if (international) {
      if (Array.isArray(formData.travelToDest)) {
        setFormData((prev) => ({
          ...prev,
          travelToDest: prev.travelToDest[0] || "flights",
        }));
      } else if (!formData.travelToDest) {
        setFormData((prev) => ({ ...prev, travelToDest: "flights" }));
      }
    } else {
      if (formData.travelToDest && !Array.isArray(formData.travelToDest)) {
        setFormData((prev) => ({
          ...prev,
          travelToDest: [prev.travelToDest],
        }));
      }
    }
  }, [formData.startingLocationData, formData.destinationData]);

  const scrollToTop = () => {
    if (rightPanelRef.current) {
      rightPanelRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const getStructuralKey = (fd) =>
    JSON.stringify({
      destinations: fd.destinations,
      destination: fd.destination,
      startingLocation: fd.startingLocation,
      startDate: fd.startDate,
      endDate: fd.endDate,
      themes: fd.themes,
      travelStyle: fd.travelStyle,
      weather: fd.weather,
      accommodation: fd.accommodation,
      food: fd.food,
      travelToDest: fd.travelToDest,
      travelBetween: fd.travelBetween,
      customNightsPerDestination: fd.customNightsPerDestination,
      stops: fd.stops,
      preferences: fd.preferences,
    });

  const startGeneration = async (fd, { force = false } = {}) => {
    Sentry.addBreadcrumb({
      category: "user-action",
      message: "Started trip generation",
      level: "info",
    });
    const stored = getStoredPlan();
    const structuralChanged =
      force ||
      !stored?.lastGeneratedFormData ||
      getStructuralKey(fd) !== getStructuralKey(stored.lastGeneratedFormData);

    if (!structuralChanged && stored?.generatedItinerary) {
      setGeneratedItinerary(stored.generatedItinerary);
      setAnalysisComplete(true);
      setCurrentStep(5);
      scrollToTop();
      return;
    }

    setCurrentStep(5);
    scrollToTop();
    setAnalysisComplete(false);
    setGeneratedItinerary(null);
    setIsValidating(true);
    setIsAnalyzing(false);
    setError(null);
    setSaveError(null);
    setValidationResult(null);

    try {
      const validation = await validateTrip(fd);
      setValidationResult(validation);

      if (!validation.valid) {
        setIsValidating(false);
        setIsAnalyzing(false);
        setAnalysisComplete(true);
        return;
      }

      setIsValidating(false);
      setIsAnalyzing(true);

      let buildup = { dayWiseItinerary: [] };
      const mergeAndShow = (patch) => {
        buildup = { ...buildup, ...patch };
        setGeneratedItinerary({
          ...buildup,
          dayWiseItinerary: [...(buildup.dayWiseItinerary || [])],
        });
      };

      const controller = new AbortController();
      if (streamAbortRef.current) streamAbortRef.current.abort();
      streamAbortRef.current = controller;

      trackEvent("itinerary_generation_started", {
        platform: getPlatform(),
      });

      const itinerary = await generateItineraryStreaming(fd, {
        signal: controller.signal,
        onEvent: (event, payload) => {
          switch (event) {
            case "skeleton": {
              mergeAndShow({
                tripSummary: {
                  destination: payload.destination,
                  startingFrom: payload.startingLocation,
                  startDate: payload.startDate,
                  endDate: payload.endDate,
                  duration: `${payload.numberOfNights} Nights / ${payload.numberOfDays} Days`,
                  travelers: payload.travelers,
                },
                _dayDates: payload.dayDates,
                _streamPhase: "skeleton",
                _streamMessage: "Generating itinerary…",
                _streamLog: ["Generating itinerary…"],
                _streaming: true,
              });
              setIsAnalyzing(false);
              setAnalysisComplete(true);
              break;
            }
            case "status": {
              const prevLog = buildup._streamLog || [];
              const nextLog =
                prevLog[prevLog.length - 1] === payload.message
                  ? prevLog
                  : [...prevLog, payload.message];
              mergeAndShow({
                _streamPhase: payload.phase,
                _streamMessage: payload.message,
                _streamLog: nextLog,
              });
              break;
            }
            case "cities": {
              mergeAndShow({
                tripSummary: {
                  ...(buildup.tripSummary || {}),
                  tripTitle:
                    payload.tripTitle || buildup.tripSummary?.tripTitle,
                  overview: payload.overview || buildup.tripSummary?.overview,
                  citiesBreakdown: payload.citiesBreakdown,
                },
                _streamPhase: "cities",
              });
              break;
            }
            case "trip_summary": {
              mergeAndShow({
                tripSummary: {
                  ...(buildup.tripSummary || {}),
                  ...(payload.tripSummary || {}),
                },
                accommodationDetails: payload.accommodationDetails,
                inclusions: payload.inclusions,
                exclusions: payload.exclusions,
                _streamPhase: "trip_summary",
              });
              break;
            }
            case "day": {
              const existing = buildup.dayWiseItinerary || [];
              const others = existing.filter(
                (d) => d.dayNumber !== payload.dayNumber,
              );
              const next = [...others, payload].sort(
                (a, b) => (a.dayNumber || 0) - (b.dayNumber || 0),
              );
              buildup = {
                ...buildup,
                dayWiseItinerary: next,
                _streamPhase: "day",
              };
              setGeneratedItinerary({
                ...buildup,
                dayWiseItinerary: [...next],
              });
              break;
            }
            case "complete": {
              buildup = {
                ...payload,
                _streamPhase: "complete",
                _streaming: false,
              };
              setGeneratedItinerary({ ...payload, _streaming: false });
              break;
            }
            case "error": {
              setError(
                payload?.message || "Generation failed. Please try again.",
              );
              setAnalysisComplete(true);
              break;
            }
            default:
              break;
          }
        },
      });

      setGeneratedItinerary(itinerary);
      setOriginalItinerary(itinerary);
      setHasModifications(false);
      setChatMessages([]);

      setStoredPlan({
        formData: fd,
        currentStep: 5,
        generatedItinerary: itinerary,
        lastGeneratedFormData: fd,
        originalItinerary: itinerary,
        hasModifications: false,
      });

      setAnalysisComplete(true);
    } catch (err) {
      if (err.name === "AbortError") return;
      Sentry.withScope((scope) => {
        scope.setTag("feature", "ai");
        scope.setTag("app", "web");
        scope.setTag("error_source", err instanceof TypeError ? "network" : "server");
        scope.setContext("trip", { destination: fd?.destinations?.map(d => d?.name)?.join(", "), budget: fd?.budget, travelers: fd?.adults });
        Sentry.captureException(new AIError(err instanceof Error ? err.message : String(err)));
      });
      console.error("Error:", err);
      if (err.validation) {
        setValidationResult(err.validation);
      } else {
        setError(
          err.message || "Failed to generate itinerary. Please try again.",
        );
      }
      setAnalysisComplete(true);
    } finally {
      streamAbortRef.current = null;
      setIsAnalyzing(false);
      setIsValidating(false);
    }
  };

  const gaJoin = (arr) => {
    const s = arr.join(", ");
    return s.length <= 100 ? s : s.slice(0, 97) + "...";
  };

  const handleNext = async () => {
    if (currentStep < 5) {
      const stepParams = { step: currentStep };

      if (currentStep === 1) {
        const destinations = (formData.stops || []).map(s => s.name).filter(Boolean);
        const startDate = formData.startDate ? new Date(formData.startDate) : null;
        const endDate = formData.endDate ? new Date(formData.endDate) : null;
        const tripDays = startDate && endDate
          ? Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24))
          : 0;

        Object.assign(stepParams, {
          origin_city: formData.startingLocation || "",
          destinations: gaJoin(destinations),
          destination_count: destinations.length,
          themes: gaJoin(formData.themes || []),
          selected_themes: (formData.themes || []).length,
          start_month: startDate ? startDate.toLocaleString("en-US", { month: "long" }) : "",
          end_month: endDate ? endDate.toLocaleString("en-US", { month: "long" }) : "",
          trip_duration_days: tripDays,
        });
      }

      if (currentStep === 2) {
        const toDest = Array.isArray(formData.travelToDest)
          ? formData.travelToDest
          : formData.travelToDest ? [formData.travelToDest] : [];
        const between = Array.isArray(formData.travelBetween)
          ? formData.travelBetween
          : [];

        Object.assign(stepParams, {
          explore_mode: formData.travelStyle || "",
          weather: gaJoin(formData.weather || []),
          trip_type: formData.tripType || "",
          accommodation_type: gaJoin(formData.accommodation || []),
          food_preference: gaJoin(formData.food || []),
          meal_plan: formData.mealPlan || "",
          departure_transport: gaJoin(toDest),
          intercity_transport: gaJoin(between),
          transport_legs: toDest.length + between.length,
          enabled: formData.includeTransport !== false,
        });
      }

      trackEvent("continue_clicked", stepParams);
    }

    if (currentStep < 2) {
      setCurrentStep(currentStep + 1);
      scrollToTop();
      return;
    }

    if (currentStep === 2) {
      const between = Array.isArray(formData.travelBetween)
        ? formData.travelBetween
        : [];
      const toDest = formData.travelToDest
        ? Array.isArray(formData.travelToDest)
          ? formData.travelToDest
          : [formData.travelToDest]
        : [];
      const allModes = [...new Set([...between, ...toDest])].filter(Boolean);

      if (formData.destinations.length >= 1 && allModes.length > 0) {
        const transportCacheKey = JSON.stringify({
          destinations: formData.destinations.map((d) => d.name || d),
          startingLocation: formData.startingLocationData?.name,
          toDest,
          between,
        });

        let result = null;
        if (
          transportCheckCacheRef.current.key === transportCacheKey &&
          transportCheckCacheRef.current.result
        ) {
          result = transportCheckCacheRef.current.result;
        } else {
          setIsCheckingTransport(true);
          try {
            const res = await routePost("/api/route/validate-and-enhance", {
              destinations: formData.destinations,
              startingLocation: formData.startingLocationData,
              travelToDest: toDest,
              travelBetween: between,
            });
            if (res.ok) {
              result = await res.json();
              transportCheckCacheRef.current = {
                key: transportCacheKey,
                result,
              };
            }
          } catch { }
          setIsCheckingTransport(false);
        }

        if (result) {
          setTransportValidation({
            ...result,
            transportModes: allModes,
            originalDestinations: formData.destinations,
            startingLocationName: formData.startingLocationData?.name || formData.startingLocation,
          });

          setSelectedLegPlans((prev) => {
            const nextPlans = { ...prev };
            const legs = Array.isArray(result.legPlans) ? result.legPlans : [];
            for (const leg of legs) {
              const prevSelectedId = nextPlans[leg.key];
              let stillExists = false;
              let fallbackIdForSameMode = null;
              
              if (prevSelectedId) {
                const optionsByMode = leg.optionsByMode || {};
                
                // First try exact ID match
                for (const mode of Object.keys(optionsByMode)) {
                  if (optionsByMode[mode].some(opt => opt.id === prevSelectedId)) {
                    stillExists = true;
                    break;
                  }
                }
                
                // If exact ID lost (e.g. AI route regeneration), try to keep the same mode
                if (!stillExists) {
                  // Guess previous mode from ID (e.g. 'flight-direct' -> 'flight')
                  const prevModeMatch = prevSelectedId.match(/^([a-z]+)-/i) || prevSelectedId.match(/^ai-([a-z]+)-/i);
                  if (prevModeMatch) {
                    const prevMode = prevModeMatch[1].toLowerCase();
                    const fuzzyMode = prevMode.replace(/s$/, ""); // e.g. flights -> flight
                    for (const mode of Object.keys(optionsByMode)) {
                      if (mode.includes(fuzzyMode) || fuzzyMode.includes(mode)) {
                        if (optionsByMode[mode].length > 0) {
                          fallbackIdForSameMode = optionsByMode[mode][0].id;
                          break;
                        }
                      }
                    }
                  }
                }
              }

              if (!stillExists) {
                if (fallbackIdForSameMode) {
                  nextPlans[leg.key] = fallbackIdForSameMode;
                } else {
                  const def = defaultOptionForLeg(leg);
                  if (def && def.id) {
                    nextPlans[leg.key] = def.id;
                  } else {
                    // Ultimate fallback: just pick the very first option available
                    const firstMode = Object.keys(leg.optionsByMode || {})[0];
                    if (firstMode && leg.optionsByMode[firstMode].length > 0) {
                      nextPlans[leg.key] = leg.optionsByMode[firstMode][0].id;
                    }
                  }
                }
              }
            }
            return nextPlans;
          });

          setCurrentStep(3);
          scrollToTop();
          return;
        }
      }

      const cleanedFormData = { ...formData, legPlans: {} };
      setFormData(cleanedFormData);
      setCurrentStep(4);
      scrollToTop();
    }

    if (currentStep === 3) {
      // This is now Transport form.
      const legs = Array.isArray(transportValidation?.legPlans) ? transportValidation.legPlans : [];
      const pickedByLegKey = {};
      for (const leg of legs) {
        const optId = selectedLegPlans[leg.key];
        const opt = optId ? findOptionById(leg, optId) : defaultOptionForLeg(leg);
        if (opt) {
          pickedByLegKey[leg.key] = {
            ...opt,
            legKey: leg.key,
            from: leg.from,
            to: leg.to,
            type: leg.type,
          };
        }
      }

      const legPlans = buildLegPlansFromValidation(transportValidation, pickedByLegKey);
      const newFormData = { ...formData, legPlans };
      setFormData(newFormData);
      setCurrentStep(4);
      scrollToTop();
    }
  };

  const handleBudgetApplyAndGenerate = async () => {
    const stepRooms = formData.rooms || [{ adults: 2, children: [] }];
    const totalAdults = stepRooms.reduce((sum, r) => sum + (r.adults || 0), 0);
    const totalChildren = stepRooms.reduce((sum, r) => sum + (r.children || []).length, 0);
    const budgetAmt = Number(formData.budget) || 0;
    const budgetRange = budgetAmt < 25000 ? "Under 25K"
      : budgetAmt < 50000 ? "25K–50K"
      : budgetAmt < 100000 ? "50K–1L"
      : budgetAmt < 250000 ? "1L–2.5L"
      : budgetAmt < 500000 ? "2.5L–5L"
      : budgetAmt < 1000000 ? "5L–10L"
      : "10L+";

    trackEvent("continue_clicked", {
      step: 4,
      adults: totalAdults,
      children: totalChildren,
      total_rooms: stepRooms.length,
      budget: budgetAmt,
      budget_range: budgetRange,
      currency: formData.currency || "INR",
      preferences_length: (formData.preferences || "").trim().length,
    });

    const destinations = (formData.stops || []).map(s => s.name).filter(Boolean);
    const startDate = formData.startDate ? new Date(formData.startDate) : null;
    const endDate = formData.endDate ? new Date(formData.endDate) : null;
    const tripDays = startDate && endDate
      ? Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24))
      : 0;
    const toDest = Array.isArray(formData.travelToDest)
      ? formData.travelToDest
      : formData.travelToDest ? [formData.travelToDest] : [];
    const between = Array.isArray(formData.travelBetween)
      ? formData.travelBetween
      : [];

    trackEvent("trip_submitted", {
      origin_city: formData.startingLocation || "",
      destinations: gaJoin(destinations),
      destination_count: destinations.length,
      themes: gaJoin(formData.themes || []),
      trip_type: formData.tripType || "",
      explore_mode: formData.travelStyle || "",
      accommodation_type: gaJoin(formData.accommodation || []),
      food_preference: gaJoin(formData.food || []),
      meal_plan: formData.mealPlan || "",
      weather: gaJoin(formData.weather || []),
      departure_transport: gaJoin(toDest),
      intercity_transport: gaJoin(between),
      transport_legs: toDest.length + between.length,
      trip_duration_days: tripDays,
      start_month: startDate ? startDate.toLocaleString("en-US", { month: "long" }) : "",
      adults: totalAdults,
      children: totalChildren,
      total_rooms: stepRooms.length,
      budget_range: budgetRange,
      budget: budgetAmt,
      currency: formData.currency || "INR",
      preferences_length: (formData.preferences || "").trim().length,
    });

    await startGeneration(formData);
  };

  // FIX: removed duplicate inner buildLegPlansFromValidation; using top-level version

  // Transport apply is now part of handleNext when currentStep === 3

  // FIX: removed reference to non-existent setShowTransportModal
  const handleTransportClose = () => {
    setTransportValidation(null);
    setIsCheckingTransport(false);
    if (formData.legPlans && Object.keys(formData.legPlans).length > 0) {
      setFormData((prev) => ({ ...prev, legPlans: {} }));
    }
  };

  const handleBack = async () => {
    trackEvent("back_clicked", {
      step: currentStep,
    });
    if (currentStep > 1) {
      if (currentStep === 5) {
        setCurrentStep(4);
        setIsAnalyzing(false);
        setIsValidating(false);
        setError(null);
        setChatMessages([]);
        if (streamAbortRef.current) streamAbortRef.current.abort();
      } else if (currentStep === 4) {
        const between = Array.isArray(formData.travelBetween) ? formData.travelBetween : [];
        const toDest = formData.travelToDest ? (Array.isArray(formData.travelToDest) ? formData.travelToDest : [formData.travelToDest]) : [];
        const allModes = [...new Set([...between, ...toDest])].filter(Boolean);
        if (formData.destinations?.length >= 1 && allModes.length > 0) {
          if (!transportValidation) {
            setIsCheckingTransport(true);
            try {
              const res = await routePost("/api/route/validate-and-enhance", {
                destinations: formData.destinations,
                startingLocation: formData.startingLocationData,
                travelToDest: toDest,
                travelBetween: between,
              });
              if (res.ok) {
                const result = await res.json();
                setTransportValidation({
                  ...result,
                  transportModes: allModes,
                  originalDestinations: formData.destinations,
                  startingLocationName: formData.startingLocationData?.name || formData.startingLocation,
                });
              }
            } catch (err) {
              Sentry.withScope((scope) => {
                scope.setTag("feature", "ai");
                scope.setTag("app", "web");
                scope.setTag("error_source", err instanceof TypeError ? "network" : "server");
                scope.setContext("trip", { destination: formData?.destinations?.map(d => d?.name)?.join(", "), budget: formData?.budget, travelers: formData?.adults });
                Sentry.captureException(new AIError(err instanceof Error ? err.message : String(err)));
              });
              console.error("Failed to fetch transport validation:", err);
            }
            setIsCheckingTransport(false);
          }
          setCurrentStep(3);
        } else {
          setCurrentStep(2);
        }
      } else {
        setCurrentStep(currentStep - 1);
      }
      scrollToTop();
    } else {
      navigate("/dashboard");
    }
  };

  const handleSubmit = async () => {
    if (generatedItinerary) {
      setSaveError(null);
      setIsPreparingItinerary(true);
      await new Promise((resolve) => setTimeout(resolve, 2000));

      setIsSaving(true);
      setIsPreparingItinerary(false);

      try {
        let tripId = editTripId;

        if (isEditMode && editTripId) {
          await updateTrip(editTripId, formData, generatedItinerary);
        } else {
          const saveResult = await saveTrip(formData, generatedItinerary);
          tripId = saveResult.tripId;
        }

        // Clear the stored plan after successful save so new trips start fresh
        clearStoredPlan();

        navigate("/itinerary", {
          state: {
            itinerary: generatedItinerary,
            tripData: formData,
            tripId: tripId,
            fromDashboard: isEditMode,
            alreadySaved: true,
          },
        });
      } catch (err) {
        Sentry.withScope((scope) => {
          scope.setTag("feature", "ai");
          scope.setTag("app", "web");
          scope.setTag("error_source", err instanceof TypeError ? "network" : "server");
          scope.setContext("trip", { destination: formData?.destinations?.map(d => d?.name)?.join(", "), budget: formData?.budget, travelers: formData?.adults });
          Sentry.captureException(new AIError(err instanceof Error ? err.message : String(err)));
        });
        console.error("Failed to save trip:", err);
        setSaveError(err.message || "Failed to save trip. Please try again.");
      } finally {
        setIsSaving(false);
      }
    }
  };

  const handleRegenerate = async () => {
    await startGeneration(formData, { force: true });
  };

  const handleRestoreOriginal = () => {
    if (originalItinerary) {
      setGeneratedItinerary(originalItinerary);
      setHasModifications(false);
      setChatMessages([]);

      setStoredPlan({
        formData,
        currentStep: 5,
        generatedItinerary: originalItinerary,
        lastGeneratedFormData: formData,
        originalItinerary: originalItinerary,
        hasModifications: false,
      });
    }
  };

  const handleProceedAnyway = async () => {
    trackEvent("validation_override_clicked");
    await startGeneration({ ...formData, skipValidation: true }, { force: true });
  };

  const handleChatMessage = async (message) => {
    const updatedMessages = [
      ...chatMessages,
      { type: "user", content: message },
    ];
    setChatMessages(updatedMessages);
    setIsModifying(true);

    try {
      const result = await modifyItinerary(
        generatedItinerary,
        message,
        formData,
        updatedMessages,
      );

      if (result.success) {
        if (result.modificationType === "off_topic") {
          setChatMessages((prev) => [
            ...prev,
            { type: "assistant", content: result.explanation },
          ]);
        } else if (result.modificationType === "needs_clarification") {
          setChatMessages((prev) => [
            ...prev,
            { type: "assistant", content: result.explanation },
          ]);
        } else if (result.modificationType !== "no_change") {
          setGeneratedItinerary(result.itinerary);
          setHasModifications(true);

          if (result.formData) {
            setFormData((prev) => ({ ...prev, ...result.formData }));
          }

          setStoredPlan({
            formData: result.formData || formData,
            currentStep: 5,
            generatedItinerary: result.itinerary,
            lastGeneratedFormData: result.formData || formData,
            originalItinerary: originalItinerary,
            hasModifications: true,
          });

          setChatMessages((prev) => [
            ...prev,
            {
              type: "assistant",
              content: result.explanation || "Itinerary updated successfully!",
            },
          ]);
        } else {
          setChatMessages((prev) => [
            ...prev,
            {
              type: "assistant",
              content: result.explanation || "No changes were needed.",
            },
          ]);
        }
      } else {
        throw new Error("Failed to modify itinerary");
      }
    } catch (err) {
      Sentry.withScope((scope) => {
        scope.setTag("feature", "ai");
        scope.setTag("app", "web");
        scope.setTag("error_source", err instanceof TypeError ? "network" : "server");
        scope.setContext("trip", { destination: formData?.destinations?.map(d => d?.name)?.join(", "), budget: formData?.budget, travelers: formData?.adults });
        Sentry.captureException(new AIError(err instanceof Error ? err.message : String(err)));
      });
      console.error("Error modifying itinerary:", err);
      setChatMessages((prev) => [
        ...prev,
        {
          type: "error",
          content: `Sorry, I couldn't make that change. ${err.message}`,
        },
      ]);
    } finally {
      setIsModifying(false);
    }
  };

  const stepInfo = STEPS[currentStep - 1] || STEPS[STEPS.length - 1];
  const showChatbot = currentStep === 5 && analysisComplete && generatedItinerary && !generatedItinerary._streaming && !error;

  return (
    <div className="h-screen flex flex-col lg:flex-row overflow-hidden">
      {/* Left Panel */}
      <div className={`lg:w-1/2 lg:h-screen lg:flex-shrink-0 bg-gradient-to-br from-teal-600 to-teal-700 text-white flex flex-col lg:min-h-0 lg:overflow-hidden transition-all duration-300 ${showChatbot ? 'p-4 lg:p-4 lg:py-4' : 'p-4 sm:p-6 lg:p-8'} ${isScrolled ? 'min-h-0' : 'min-h-[320px] sm:min-h-[380px]'}`}>
        <div className={`flex-shrink-0 transition-all duration-300 ${isScrolled ? 'mb-3 lg:mb-4' : (showChatbot ? 'mb-3 lg:mb-0' : 'mb-6')} flex items-start justify-between ${showChatbot ? 'lg:hidden' : ''}`}>
          <Link to="/" className="flex items-center gap-2 mt-1.5">
            <img src="/RoamMyWay.png" alt="RoamMyWay" className={`w-auto brightness-0 invert transition-all duration-300 ${isScrolled ? 'h-6 lg:h-8' : 'h-8'}`} />
          </Link>
          {showChatbot && (
            <div className="hidden lg:block text-right select-none max-w-[240px]">
              <h1 className="text-base font-bold leading-tight">
                {stepInfo.title}
              </h1>
              <p className="text-teal-100 text-[11px] leading-snug font-medium opacity-90 mt-0.5">
                {stepInfo.subtitle}
              </p>
            </div>
          )}
        </div>

        <div className={`flex-shrink-0 transition-all duration-300 overflow-hidden ${showChatbot ? 'lg:hidden ' : ''}${isScrolled ? 'max-h-0 opacity-0 mb-0 lg:max-h-[300px] lg:opacity-100 lg:mb-4' : 'max-h-[300px] opacity-100 mb-4'}`}>
          <div className="mb-4 sm:mb-6 pt-2 px-1">
            <StepIndicator currentStep={currentStep} />
          </div>
          <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold whitespace-pre-line mb-1 sm:mb-3">
            {stepInfo.title}
          </h1>
          <p className="text-teal-100 text-xs sm:text-sm lg:text-base">
            {stepInfo.subtitle}
          </p>
        </div>

        <div className="flex flex-col flex-1 min-h-0 mt-2 sm:mt-4 lg:mt-0 lg:overflow-hidden">
          {showChatbot ? (
            <>
              {/* Desktop: map + chatbot stacked */}
              <div className="hidden lg:flex flex-col flex-1 min-h-0 gap-5 pb-1">
                <div className="w-full flex-[0.4] min-h-0 shrink-0 rounded-2xl overflow-hidden border border-white/15 shadow-xl bg-white relative">
                  <Step1Map
                    fromLocation={formData.startingLocationData}
                    destinations={formData.destinations}
                  />
                </div>
                <div className="w-full flex-[0.6] flex flex-col min-h-0">
                  <ItineraryChatbot
                    onSendMessage={handleChatMessage}
                    isProcessing={isModifying}
                    messages={chatMessages}
                    hasModifications={hasModifications}
                    onRestoreOriginal={handleRestoreOriginal}
                  />
                </div>
              </div>

              {/* Mobile: map only (chatbot rendered separately below) */}
              <div className="lg:hidden rounded-2xl overflow-hidden h-[180px] sm:h-[220px]">
                <Step1Map
                  fromLocation={formData.startingLocationData}
                  destinations={formData.destinations}
                />
              </div>
            </>
          ) : (
            <div className="rounded-2xl overflow-hidden h-[180px] sm:h-[220px] lg:flex-1 lg:h-full">
              <Step1Map
                fromLocation={formData.startingLocationData}
                destinations={formData.destinations}
              />
            </div>
          )}
        </div>
      </div>

      {/* Right Panel */}
      <div
        ref={rightPanelRef}
        onScroll={(e) => setIsScrolled(e.target.scrollTop > 30)}
        className="lg:w-1/2 lg:h-screen flex-1 overflow-y-auto bg-white w-full flex flex-col relative"
      >
        <div ref={contentTopRef} className="flex-1 max-w-2xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-5 sm:py-8 lg:py-12 pb-28 lg:pb-12">
          <div className="mb-8 flex justify-between items-start">
            <div>
              <div className="flex items-center gap-2 mb-1">
                <p className="text-sm text-teal-600 font-semibold">
                  STEP {currentStep} OF 5
                </p>
                {isEditMode && (
                  <span className="px-2 py-0.5 bg-blue-100 text-blue-700 text-xs font-medium rounded-full">
                    Editing
                  </span>
                )}
              </div>
              <h2 className="text-2xl font-bold text-gray-900">
                {currentStep === 1 && "Destination & Dates"}
                {currentStep === 2 && "Travel Preferences"}
                {currentStep === 3 && "Choose Transport"}
                {currentStep === 4 && "Budget & Travelers"}
                {currentStep === 5 && (isEditMode ? "Review Changes" : "AI Suggestions")}
              </h2>
            </div>

            {currentStep < 5 && (
              <button
                type="button"
                onClick={() => {
                  trackEvent("clear_all_clicked", { step: currentStep });

                  if (currentStep === 1) {
                    setFormData((prev) => ({
                      ...prev,
                      startingLocation: "",
                      startingLocationData: null,
                      destinations: [],
                      destination: "",
                      destinationData: null,
                      customNightsPerDestination: {},
                      startDate: null,
                      endDate: null,
                      themes: [],
                    }));
                  } else if (currentStep === 2) {
                    setFormData((prev) => ({
                      ...prev,
                      travelStyle: "",
                      weather: [],
                      accommodation: [],
                      food: [],
                      travelToDest: isInternationalTrip() ? "" : [],
                      travelBetween: [],
                    }));
                  } else if (currentStep === 3) {
                    setFormData((prev) => ({
                      ...prev,
                      adults: 1,
                      children: 0,
                      infants: 0,
                      currency: "INR",
                      budget: "",
                      preferences: "",
                    }));
                  } else if (currentStep === 4) {
                    const init = {};
                    const legs = Array.isArray(transportValidation?.legPlans) ? transportValidation.legPlans : [];
                    for (const leg of legs) {
                      const def = defaultOptionForLeg(leg);
                      if (def) init[leg.key] = def.id;
                    }
                    setSelectedLegPlans(init);
                  }
                }}
                className="text-sm text-gray-500 hover:text-red-500 font-medium flex items-center gap-1 cursor-pointer transition-colors mt-1"
                title={currentStep === 4 ? "Reset Selections" : `Clear Step ${currentStep}`}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
                {currentStep === 4 ? "Reset Selections" : "Clear All"}
              </button>
            )}
          </div>

          <div className="mb-12">
            {currentStep === 1 && (
              <Step1Form
                formData={formData}
                setFormData={setFormData}
                onOptimizePendingChange={setIsOptimizePending}
              />
            )}
            {currentStep === 2 && (
              <Step2Form
                formData={formData}
                setFormData={setFormData}
                isInternationalTrip={isInternationalTrip()}
                showErrors={showStepErrors}
              />
            )}
            {currentStep === 4 && (
              <Step3Form formData={formData} setFormData={setFormData} />
            )}
            {currentStep === 3 && (
              <Step4TransportForm
                validation={transportValidation}
                selected={selectedLegPlans}
                onSelect={(legKey, optionId) => {
                  setSelectedLegPlans((prev) => ({ ...prev, [legKey]: optionId }));
                }}
              />
            )}
            {currentStep === 5 && (
              <Step4Form
                formData={formData}
                isAnalyzing={isAnalyzing}
                isValidating={isValidating}
                analysisComplete={analysisComplete}
                itinerary={generatedItinerary}
                error={error}
                saveError={saveError}
                onRetrySave={handleSubmit}
                validationResult={validationResult}
                isEditMode={isEditMode}
                onRegenerate={handleRegenerate}
                onProceedAnyway={handleProceedAnyway}
                onGoToStep={setCurrentStep}
              />
            )}
          </div>

          {/* Mobile chatbot — floating icon & modal */}
          {showChatbot && (
            <div className="lg:hidden">
              <button
                onClick={() => setShowMobileChat(true)}
                className="fixed bottom-24 right-4 z-[65] bg-teal-600 text-white w-14 h-14 rounded-full shadow-[0_0_15px_rgba(13,148,136,0.6)] flex items-center justify-center animate-bounce hover:bg-teal-700 transition-colors border-[3px] border-white/50 backdrop-blur-sm"
              >
                <FontAwesomeIcon icon={faComments} className="text-xl" />
              </button>

              {showMobileChat && (
                <div className="fixed inset-0 z-[70] bg-black/60 backdrop-blur-sm flex flex-col justify-end transition-opacity">
                  <div className="bg-gradient-to-br from-teal-900 to-teal-800 w-full h-[85vh] rounded-t-[32px] shadow-2xl flex flex-col overflow-hidden animate-[slideUp_0.3s_ease-out]">
                    <div className="flex-1 overflow-hidden p-2 relative pt-4">
                      <ItineraryChatbot
                        onSendMessage={handleChatMessage}
                        isProcessing={isModifying}
                        messages={chatMessages}
                        hasModifications={hasModifications}
                        onRestoreOriginal={handleRestoreOriginal}
                        onClose={() => setShowMobileChat(false)}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Sticky bottom nav */}
        <div className="fixed bottom-0 left-0 right-0 w-full lg:sticky lg:bottom-0 bg-white border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)] z-[60] lg:z-20">
          <div className="max-w-2xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
            <button
              onClick={handleBack}
              disabled={isCheckingTransport}
              className={`inline-flex items-center gap-2 px-6 py-3 border rounded-full font-medium transition-colors ${isCheckingTransport
                ? "border-gray-200 text-gray-300 cursor-not-allowed"
                : "border-gray-300 text-gray-700 hover:bg-gray-50"
                }`}
            >
              <ArrowLeftIcon />
              Back
            </button>

            {currentStep < 5 ? (
              currentStep === 4 ? (
                <button
                  onClick={handleBudgetApplyAndGenerate}
                  disabled={!isStepValid(4) || isAnalyzing}
                  className={`inline-flex items-center gap-2 px-6 py-3 rounded-full font-medium transition-colors ${isStepValid(4) && !isAnalyzing
                    ? "bg-teal-600 text-white hover:bg-teal-700 cursor-pointer"
                    : "bg-gray-300 text-gray-500 cursor-not-allowed"
                    }`}
                >
                  {isAnalyzing ? (
                    <>
                      <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                      </svg>
                      Generating...
                    </>
                  ) : (
                    <>
                      Generate Itinerary
                      <ArrowRightIcon />
                    </>
                  )}
                </button>
              ) : (
                <button
                  onClick={() => {
                    if (!isStepValid(currentStep)) {
                      setShowStepErrors(true);
                      toast.warning(
                        getStepValidationMessage(currentStep) ||
                          "Please complete this step before continuing."
                      );
                      return;
                    }
                    handleNext();
                  }}
                  disabled={isCheckingTransport || (isOptimizePending && currentStep === 1)}
                  className={`inline-flex items-center gap-2 px-6 py-3 rounded-full font-medium transition-colors ${isStepValid(currentStep) && !isCheckingTransport && !(isOptimizePending && currentStep === 1)
                    ? "bg-teal-600 text-white hover:bg-teal-700 cursor-pointer"
                    : "bg-gray-300 text-gray-500 cursor-not-allowed"
                    }`}
                >
                  {isCheckingTransport && currentStep === 2 ? (
                    <>
                      <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                      </svg>
                      Checking route...
                    </>
                  ) : (
                    <>
                      Continue
                      <ArrowRightIcon />
                    </>
                  )}
                </button>
              )
            ) : analysisComplete && generatedItinerary && !error && !generatedItinerary._streaming ? (
              <button
                onClick={handleSubmit}
                disabled={isSaving || isPreparingItinerary}
                className={`inline-flex items-center gap-2 px-8 py-3 rounded-full font-medium transition-colors ${isSaving || isPreparingItinerary
                  ? "bg-teal-400 text-white cursor-not-allowed"
                  : "bg-teal-600 text-white hover:bg-teal-700 cursor-pointer"
                  }`}
              >
                {isSaving || isPreparingItinerary ? (
                  <>
                    <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                    </svg>
                    Saving...
                  </>
                ) : (
                  <>
                    {isEditMode ? "Save Changes" : "View Trip"}
                    <ArrowRightIcon />
                  </>
                )}
              </button>
            ) : null}
          </div>
        </div>
      </div>

      {/* Full-screen preparing overlay */}
      {isPreparingItinerary && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-teal-600 to-teal-800">
          <div className="text-center text-white px-8">
            <div className="relative mb-8">
              <div className="w-24 h-24 border-4 border-white/20 rounded-full animate-spin border-t-white mx-auto"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="text-4xl">✨</span>
              </div>
            </div>
            <h2 className="text-2xl font-bold mb-3">
              Romaya is finalizing your adventure...
            </h2>
            <p className="text-teal-100 text-lg mb-6">
              Adding the finishing touches to your perfect trip
            </p>
            <div className="flex items-center justify-center gap-3 text-teal-200 text-sm">
              <span className="w-2 h-2 bg-white rounded-full animate-pulse"></span>
              <span className="animate-pulse">Preparing your personalized itinerary</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}